// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/billing.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { DateRange } from "./usage_pb.js";

/**
 * @generated from enum gitpod.v1.BillingPlanKind
 */
export enum BillingPlanKind {
  /**
   * @generated from enum value: BILLING_PLAN_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_PLAN_KIND_FREE = 1;
   */
  FREE = 1,

  /**
   * @generated from enum value: BILLING_PLAN_KIND_CORE = 2;
   */
  CORE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(BillingPlanKind)
proto3.util.setEnumType(BillingPlanKind, "gitpod.v1.BillingPlanKind", [
  { no: 0, name: "BILLING_PLAN_KIND_UNSPECIFIED" },
  { no: 1, name: "BILLING_PLAN_KIND_FREE" },
  { no: 2, name: "BILLING_PLAN_KIND_CORE" },
]);

/**
 * @generated from enum gitpod.v1.CreditCardVerificationStatus
 */
export enum CreditCardVerificationStatus {
  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_REQUIRES_CONFIRMATION = 2;
   */
  REQUIRES_CONFIRMATION = 2,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_INVALID_CVC = 3;
   */
  INVALID_CVC = 3,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_INVALID_NUMBER = 4;
   */
  INVALID_NUMBER = 4,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_INSUFFICIENT_FUNDS = 5;
   */
  INSUFFICIENT_FUNDS = 5,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_EXPIRED_CARD = 6;
   */
  EXPIRED_CARD = 6,

  /**
   * catch all for all other errors
   *
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_FAILED = 7;
   */
  FAILED = 7,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_SUCCESS = 8;
   */
  SUCCESS = 8,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_NOT_REQUIRED = 9;
   */
  NOT_REQUIRED = 9,
}
// Retrieve enum metadata with: proto3.getEnumType(CreditCardVerificationStatus)
proto3.util.setEnumType(CreditCardVerificationStatus, "gitpod.v1.CreditCardVerificationStatus", [
  { no: 0, name: "CREDIT_CARD_VERIFICATION_STATUS_UNSPECIFIED" },
  { no: 1, name: "CREDIT_CARD_VERIFICATION_STATUS_PENDING" },
  { no: 2, name: "CREDIT_CARD_VERIFICATION_STATUS_REQUIRES_CONFIRMATION" },
  { no: 3, name: "CREDIT_CARD_VERIFICATION_STATUS_INVALID_CVC" },
  { no: 4, name: "CREDIT_CARD_VERIFICATION_STATUS_INVALID_NUMBER" },
  { no: 5, name: "CREDIT_CARD_VERIFICATION_STATUS_INSUFFICIENT_FUNDS" },
  { no: 6, name: "CREDIT_CARD_VERIFICATION_STATUS_EXPIRED_CARD" },
  { no: 7, name: "CREDIT_CARD_VERIFICATION_STATUS_FAILED" },
  { no: 8, name: "CREDIT_CARD_VERIFICATION_STATUS_SUCCESS" },
  { no: 9, name: "CREDIT_CARD_VERIFICATION_STATUS_NOT_REQUIRED" },
]);

/**
 * @generated from enum gitpod.v1.PaymentFailureState
 */
export enum PaymentFailureState {
  /**
   * @generated from enum value: PAYMENT_FAILURE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_FAILURE_STATE_IN_GRACE = 1;
   */
  IN_GRACE = 1,

  /**
   * @generated from enum value: PAYMENT_FAILURE_STATE_SUSPENDED = 2;
   */
  SUSPENDED = 2,

  /**
   * @generated from enum value: PAYMENT_FAILURE_STATE_RESOLVED = 3;
   */
  RESOLVED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(PaymentFailureState)
proto3.util.setEnumType(PaymentFailureState, "gitpod.v1.PaymentFailureState", [
  { no: 0, name: "PAYMENT_FAILURE_STATE_UNSPECIFIED" },
  { no: 1, name: "PAYMENT_FAILURE_STATE_IN_GRACE" },
  { no: 2, name: "PAYMENT_FAILURE_STATE_SUSPENDED" },
  { no: 3, name: "PAYMENT_FAILURE_STATE_RESOLVED" },
]);

/**
 * @generated from enum gitpod.v1.CreditStatus
 */
export enum CreditStatus {
  /**
   * @generated from enum value: CREDIT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CREDIT_STATUS_OUT_OF_CREDITS = 1;
   */
  OUT_OF_CREDITS = 1,

  /**
   * @generated from enum value: CREDIT_STATUS_LOW_ON_CREDITS = 2;
   */
  LOW_ON_CREDITS = 2,

  /**
   * @generated from enum value: CREDIT_STATUS_HAS_CREDITS = 3;
   */
  HAS_CREDITS = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(CreditStatus)
proto3.util.setEnumType(CreditStatus, "gitpod.v1.CreditStatus", [
  { no: 0, name: "CREDIT_STATUS_UNSPECIFIED" },
  { no: 1, name: "CREDIT_STATUS_OUT_OF_CREDITS" },
  { no: 2, name: "CREDIT_STATUS_LOW_ON_CREDITS" },
  { no: 3, name: "CREDIT_STATUS_HAS_CREDITS" },
]);

/**
 * @generated from enum gitpod.v1.PaymentMethodStatus
 */
export enum PaymentMethodStatus {
  /**
   * @generated from enum value: PAYMENT_METHOD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_METHOD_STATUS_NOT_SET_UP = 1;
   */
  NOT_SET_UP = 1,

  /**
   * @generated from enum value: PAYMENT_METHOD_STATUS_VERIFIED = 2;
   */
  VERIFIED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PaymentMethodStatus)
proto3.util.setEnumType(PaymentMethodStatus, "gitpod.v1.PaymentMethodStatus", [
  { no: 0, name: "PAYMENT_METHOD_STATUS_UNSPECIFIED" },
  { no: 1, name: "PAYMENT_METHOD_STATUS_NOT_SET_UP" },
  { no: 2, name: "PAYMENT_METHOD_STATUS_VERIFIED" },
]);

/**
 * @generated from enum gitpod.v1.BillingRealm
 */
export enum BillingRealm {
  /**
   * @generated from enum value: BILLING_REALM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_REALM_SANDBOX = 1;
   */
  SANDBOX = 1,

  /**
   * @generated from enum value: BILLING_REALM_PRODUCTION = 2;
   */
  PRODUCTION = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(BillingRealm)
proto3.util.setEnumType(BillingRealm, "gitpod.v1.BillingRealm", [
  { no: 0, name: "BILLING_REALM_UNSPECIFIED" },
  { no: 1, name: "BILLING_REALM_SANDBOX" },
  { no: 2, name: "BILLING_REALM_PRODUCTION" },
]);

/**
 * @generated from enum gitpod.v1.SubscriptionType
 */
export enum SubscriptionType {
  /**
   * @generated from enum value: SUBSCRIPTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUBSCRIPTION_TYPE_CORE = 1;
   */
  CORE = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(SubscriptionType)
proto3.util.setEnumType(SubscriptionType, "gitpod.v1.SubscriptionType", [
  { no: 0, name: "SUBSCRIPTION_TYPE_UNSPECIFIED" },
  { no: 1, name: "SUBSCRIPTION_TYPE_CORE" },
]);

/**
 * @generated from enum gitpod.v1.SubscriptionStatus
 */
export enum SubscriptionStatus {
  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_CANCELLED = 2;
   */
  CANCELLED = 2,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_EXPIRED = 3;
   */
  EXPIRED = 3,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_PENDING = 4;
   */
  PENDING = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(SubscriptionStatus)
proto3.util.setEnumType(SubscriptionStatus, "gitpod.v1.SubscriptionStatus", [
  { no: 0, name: "SUBSCRIPTION_STATUS_UNSPECIFIED" },
  { no: 1, name: "SUBSCRIPTION_STATUS_ACTIVE" },
  { no: 2, name: "SUBSCRIPTION_STATUS_CANCELLED" },
  { no: 3, name: "SUBSCRIPTION_STATUS_EXPIRED" },
  { no: 4, name: "SUBSCRIPTION_STATUS_PENDING" },
]);

/**
 * UsageType identifies the category of usage.
 *
 * @generated from enum gitpod.v1.UsageType
 */
export enum UsageType {
  /**
   * @generated from enum value: USAGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USAGE_TYPE_ENVIRONMENT = 1;
   */
  ENVIRONMENT = 1,

  /**
   * @generated from enum value: USAGE_TYPE_AGENTIC = 2;
   */
  AGENTIC = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(UsageType)
proto3.util.setEnumType(UsageType, "gitpod.v1.UsageType", [
  { no: 0, name: "USAGE_TYPE_UNSPECIFIED" },
  { no: 1, name: "USAGE_TYPE_ENVIRONMENT" },
  { no: 2, name: "USAGE_TYPE_AGENTIC" },
]);

/**
 * @generated from message gitpod.v1.BillingRecord
 */
export class BillingRecord extends Message<BillingRecord> {
  /**
   * id is the unique identifier for the billing record
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gitpod.v1.BillingRecordMetadata metadata = 2;
   */
  metadata?: BillingRecordMetadata;

  /**
   * @generated from field: gitpod.v1.BillingRecordSpec spec = 3;
   */
  spec?: BillingRecordSpec;

  /**
   * @generated from field: gitpod.v1.BillingRecordStatus status = 4;
   */
  status?: BillingRecordStatus;

  constructor(data?: PartialMessage<BillingRecord>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.BillingRecord";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: BillingRecordMetadata },
    { no: 3, name: "spec", kind: "message", T: BillingRecordSpec },
    { no: 4, name: "status", kind: "message", T: BillingRecordStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BillingRecord {
    return new BillingRecord().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BillingRecord {
    return new BillingRecord().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BillingRecord {
    return new BillingRecord().fromJsonString(jsonString, options);
  }

  static equals(a: BillingRecord | PlainMessage<BillingRecord> | undefined, b: BillingRecord | PlainMessage<BillingRecord> | undefined): boolean {
    return proto3.util.equals(BillingRecord, a, b);
  }
}

/**
 * @generated from message gitpod.v1.BillingRecordMetadata
 */
export class BillingRecordMetadata extends Message<BillingRecordMetadata> {
  /**
   * organization_id is the ID of the organization that owns the record
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * realm is the billing realm (sandbox or production)
   *
   * @generated from field: gitpod.v1.BillingRealm realm = 2;
   */
  realm = BillingRealm.UNSPECIFIED;

  /**
   * created_at is the time the record was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is the time the record was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<BillingRecordMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.BillingRecordMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "realm", kind: "enum", T: proto3.getEnumType(BillingRealm) },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BillingRecordMetadata {
    return new BillingRecordMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BillingRecordMetadata {
    return new BillingRecordMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BillingRecordMetadata {
    return new BillingRecordMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: BillingRecordMetadata | PlainMessage<BillingRecordMetadata> | undefined, b: BillingRecordMetadata | PlainMessage<BillingRecordMetadata> | undefined): boolean {
    return proto3.util.equals(BillingRecordMetadata, a, b);
  }
}

/**
 * @generated from message gitpod.v1.BillingRecordSpec
 */
export class BillingRecordSpec extends Message<BillingRecordSpec> {
  /**
   * plan contains the plan details
   *
   * @generated from field: gitpod.v1.BillingPlanSpec plan = 1;
   */
  plan?: BillingPlanSpec;

  constructor(data?: PartialMessage<BillingRecordSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.BillingRecordSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan", kind: "message", T: BillingPlanSpec },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BillingRecordSpec {
    return new BillingRecordSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BillingRecordSpec {
    return new BillingRecordSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BillingRecordSpec {
    return new BillingRecordSpec().fromJsonString(jsonString, options);
  }

  static equals(a: BillingRecordSpec | PlainMessage<BillingRecordSpec> | undefined, b: BillingRecordSpec | PlainMessage<BillingRecordSpec> | undefined): boolean {
    return proto3.util.equals(BillingRecordSpec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.BillingPlanSpec
 */
export class BillingPlanSpec extends Message<BillingPlanSpec> {
  /**
   * kind contains the kind of plan
   *
   * @generated from field: gitpod.v1.BillingPlanKind kind = 1;
   */
  kind = BillingPlanKind.UNSPECIFIED;

  /**
   * amount_cents contains the amount of cents to charge the organization
   *
   * @generated from field: int64 amount_cents_usd = 2;
   */
  amountCentsUsd = protoInt64.zero;

  /**
   * version contains the version of the plan
   *
   * @generated from field: string version_id = 3;
   */
  versionId = "";

  constructor(data?: PartialMessage<BillingPlanSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.BillingPlanSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(BillingPlanKind) },
    { no: 2, name: "amount_cents_usd", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "version_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BillingPlanSpec {
    return new BillingPlanSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BillingPlanSpec {
    return new BillingPlanSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BillingPlanSpec {
    return new BillingPlanSpec().fromJsonString(jsonString, options);
  }

  static equals(a: BillingPlanSpec | PlainMessage<BillingPlanSpec> | undefined, b: BillingPlanSpec | PlainMessage<BillingPlanSpec> | undefined): boolean {
    return proto3.util.equals(BillingPlanSpec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.BillingRecordStatus
 */
export class BillingRecordStatus extends Message<BillingRecordStatus> {
  /**
   * plan contains the plan status
   *
   * @generated from field: gitpod.v1.BillingPlanStatus plan = 1;
   */
  plan?: BillingPlanStatus;

  /**
   * card_verification contains the status of the card verification
   *
   * @generated from field: gitpod.v1.PaymentMethodVerificationStatus payment_method_verification = 2;
   */
  paymentMethodVerification?: PaymentMethodVerificationStatus;

  /**
   * credit contains the status of the credit balance
   *
   * @generated from field: gitpod.v1.CreditStatus credit = 3;
   */
  credit = CreditStatus.UNSPECIFIED;

  /**
   * error contains any error message
   *
   * @generated from field: string error = 4;
   */
  error = "";

  constructor(data?: PartialMessage<BillingRecordStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.BillingRecordStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan", kind: "message", T: BillingPlanStatus },
    { no: 2, name: "payment_method_verification", kind: "message", T: PaymentMethodVerificationStatus },
    { no: 3, name: "credit", kind: "enum", T: proto3.getEnumType(CreditStatus) },
    { no: 4, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BillingRecordStatus {
    return new BillingRecordStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BillingRecordStatus {
    return new BillingRecordStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BillingRecordStatus {
    return new BillingRecordStatus().fromJsonString(jsonString, options);
  }

  static equals(a: BillingRecordStatus | PlainMessage<BillingRecordStatus> | undefined, b: BillingRecordStatus | PlainMessage<BillingRecordStatus> | undefined): boolean {
    return proto3.util.equals(BillingRecordStatus, a, b);
  }
}

/**
 * @generated from message gitpod.v1.BillingPlanStatus
 */
export class BillingPlanStatus extends Message<BillingPlanStatus> {
  /**
   * kind contains the kind of plan
   *
   * @generated from field: gitpod.v1.BillingPlanKind kind = 1;
   */
  kind = BillingPlanKind.UNSPECIFIED;

  /**
   * amount_cents contains the amount of cents to charge the organization
   *
   * @generated from field: int64 amount_cents_usd = 2;
   */
  amountCentsUsd = protoInt64.zero;

  /**
   * ending_at contains the date and time when the plan ends
   *
   * @generated from field: google.protobuf.Timestamp ending_at = 3;
   */
  endingAt?: Timestamp;

  /**
   * version contains the version of the plan
   *
   * @generated from field: string version_id = 4;
   */
  versionId = "";

  constructor(data?: PartialMessage<BillingPlanStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.BillingPlanStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(BillingPlanKind) },
    { no: 2, name: "amount_cents_usd", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "ending_at", kind: "message", T: Timestamp },
    { no: 4, name: "version_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BillingPlanStatus {
    return new BillingPlanStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BillingPlanStatus {
    return new BillingPlanStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BillingPlanStatus {
    return new BillingPlanStatus().fromJsonString(jsonString, options);
  }

  static equals(a: BillingPlanStatus | PlainMessage<BillingPlanStatus> | undefined, b: BillingPlanStatus | PlainMessage<BillingPlanStatus> | undefined): boolean {
    return proto3.util.equals(BillingPlanStatus, a, b);
  }
}

/**
 * @generated from message gitpod.v1.PaymentMethodVerificationStatus
 */
export class PaymentMethodVerificationStatus extends Message<PaymentMethodVerificationStatus> {
  /**
   * status contains the status of the card verification
   *
   * @generated from field: gitpod.v1.CreditCardVerificationStatus card_verification_status = 1;
   */
  cardVerificationStatus = CreditCardVerificationStatus.UNSPECIFIED;

  /**
   * error contains any error message
   *
   * @generated from field: string error = 2;
   */
  error = "";

  constructor(data?: PartialMessage<PaymentMethodVerificationStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PaymentMethodVerificationStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "card_verification_status", kind: "enum", T: proto3.getEnumType(CreditCardVerificationStatus) },
    { no: 2, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentMethodVerificationStatus {
    return new PaymentMethodVerificationStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentMethodVerificationStatus {
    return new PaymentMethodVerificationStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentMethodVerificationStatus {
    return new PaymentMethodVerificationStatus().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentMethodVerificationStatus | PlainMessage<PaymentMethodVerificationStatus> | undefined, b: PaymentMethodVerificationStatus | PlainMessage<PaymentMethodVerificationStatus> | undefined): boolean {
    return proto3.util.equals(PaymentMethodVerificationStatus, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetBillingRecordRequest
 */
export class GetBillingRecordRequest extends Message<GetBillingRecordRequest> {
  /**
   * billing_record_id specifies the billing record identifier
   *
   * @generated from field: string billing_record_id = 1;
   */
  billingRecordId = "";

  constructor(data?: PartialMessage<GetBillingRecordRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetBillingRecordRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "billing_record_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingRecordRequest {
    return new GetBillingRecordRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingRecordRequest {
    return new GetBillingRecordRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingRecordRequest {
    return new GetBillingRecordRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingRecordRequest | PlainMessage<GetBillingRecordRequest> | undefined, b: GetBillingRecordRequest | PlainMessage<GetBillingRecordRequest> | undefined): boolean {
    return proto3.util.equals(GetBillingRecordRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetBillingRecordResponse
 */
export class GetBillingRecordResponse extends Message<GetBillingRecordResponse> {
  /**
   * @generated from field: gitpod.v1.BillingRecord billing_record = 1;
   */
  billingRecord?: BillingRecord;

  constructor(data?: PartialMessage<GetBillingRecordResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetBillingRecordResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "billing_record", kind: "message", T: BillingRecord },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingRecordResponse {
    return new GetBillingRecordResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingRecordResponse {
    return new GetBillingRecordResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingRecordResponse {
    return new GetBillingRecordResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingRecordResponse | PlainMessage<GetBillingRecordResponse> | undefined, b: GetBillingRecordResponse | PlainMessage<GetBillingRecordResponse> | undefined): boolean {
    return proto3.util.equals(GetBillingRecordResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateBillingRecordRequest
 */
export class UpdateBillingRecordRequest extends Message<UpdateBillingRecordRequest> {
  /**
   * billing_record_id is the ID of the billing record to update
   *
   * @generated from field: string billing_record_id = 1;
   */
  billingRecordId = "";

  /**
   * kind contains the kind of plan
   *
   * @generated from field: optional gitpod.v1.BillingPlanKind kind = 2;
   */
  kind?: BillingPlanKind;

  /**
   * amount_cents contains the amount of cents to charge the organization
   *
   * @generated from field: optional int64 amount_cents_usd = 3;
   */
  amountCentsUsd?: bigint;

  constructor(data?: PartialMessage<UpdateBillingRecordRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateBillingRecordRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "billing_record_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kind", kind: "enum", T: proto3.getEnumType(BillingPlanKind), opt: true },
    { no: 3, name: "amount_cents_usd", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateBillingRecordRequest {
    return new UpdateBillingRecordRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateBillingRecordRequest {
    return new UpdateBillingRecordRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateBillingRecordRequest {
    return new UpdateBillingRecordRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateBillingRecordRequest | PlainMessage<UpdateBillingRecordRequest> | undefined, b: UpdateBillingRecordRequest | PlainMessage<UpdateBillingRecordRequest> | undefined): boolean {
    return proto3.util.equals(UpdateBillingRecordRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateBillingRecordResponse
 */
export class UpdateBillingRecordResponse extends Message<UpdateBillingRecordResponse> {
  constructor(data?: PartialMessage<UpdateBillingRecordResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateBillingRecordResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateBillingRecordResponse {
    return new UpdateBillingRecordResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateBillingRecordResponse {
    return new UpdateBillingRecordResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateBillingRecordResponse {
    return new UpdateBillingRecordResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateBillingRecordResponse | PlainMessage<UpdateBillingRecordResponse> | undefined, b: UpdateBillingRecordResponse | PlainMessage<UpdateBillingRecordResponse> | undefined): boolean {
    return proto3.util.equals(UpdateBillingRecordResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetupBillingRequest
 */
export class SetupBillingRequest extends Message<SetupBillingRequest> {
  /**
   * organization_id is the ID of the organization to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<SetupBillingRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetupBillingRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetupBillingRequest {
    return new SetupBillingRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetupBillingRequest {
    return new SetupBillingRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetupBillingRequest {
    return new SetupBillingRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetupBillingRequest | PlainMessage<SetupBillingRequest> | undefined, b: SetupBillingRequest | PlainMessage<SetupBillingRequest> | undefined): boolean {
    return proto3.util.equals(SetupBillingRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetupBillingResponse
 */
export class SetupBillingResponse extends Message<SetupBillingResponse> {
  /**
   * setup_intent_client_secret is the client secret for the Stripe SetupIntent
   *
   * @generated from field: string setup_intent_client_secret = 1;
   */
  setupIntentClientSecret = "";

  /**
   * customer_session_client_secret is the client secret for the Stripe CustomerSession
   *
   * @generated from field: string customer_session_client_secret = 2;
   */
  customerSessionClientSecret = "";

  constructor(data?: PartialMessage<SetupBillingResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetupBillingResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "setup_intent_client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "customer_session_client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetupBillingResponse {
    return new SetupBillingResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetupBillingResponse {
    return new SetupBillingResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetupBillingResponse {
    return new SetupBillingResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetupBillingResponse | PlainMessage<SetupBillingResponse> | undefined, b: SetupBillingResponse | PlainMessage<SetupBillingResponse> | undefined): boolean {
    return proto3.util.equals(SetupBillingResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CompleteBillingSetupRequest
 */
export class CompleteBillingSetupRequest extends Message<CompleteBillingSetupRequest> {
  /**
   * organization_id is the ID of the organization to complete billing setup for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * setup_intent_id is the Stripe SetupIntent ID to verify completion
   *
   * @generated from field: string setup_intent_id = 2;
   */
  setupIntentId = "";

  constructor(data?: PartialMessage<CompleteBillingSetupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CompleteBillingSetupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "setup_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteBillingSetupRequest {
    return new CompleteBillingSetupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteBillingSetupRequest {
    return new CompleteBillingSetupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteBillingSetupRequest {
    return new CompleteBillingSetupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteBillingSetupRequest | PlainMessage<CompleteBillingSetupRequest> | undefined, b: CompleteBillingSetupRequest | PlainMessage<CompleteBillingSetupRequest> | undefined): boolean {
    return proto3.util.equals(CompleteBillingSetupRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CompleteBillingSetupResponse
 */
export class CompleteBillingSetupResponse extends Message<CompleteBillingSetupResponse> {
  /**
   * contract_id is the Metronome contract ID created for the organization
   *
   * @generated from field: string contract_id = 1;
   */
  contractId = "";

  /**
   * trial_granted indicates whether a free trial was successfully granted
   *
   * @generated from field: bool trial_granted = 2;
   */
  trialGranted = false;

  /**
   * trial_amount_credits is the amount of trial credits granted in Gitpod Credits
   *
   * @generated from field: double trial_amount_credits = 3;
   */
  trialAmountCredits = 0;

  /**
   * trial_expires_at is when the trial credits expire
   *
   * @generated from field: google.protobuf.Timestamp trial_expires_at = 4;
   */
  trialExpiresAt?: Timestamp;

  constructor(data?: PartialMessage<CompleteBillingSetupResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CompleteBillingSetupResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contract_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "trial_granted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "trial_amount_credits", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "trial_expires_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteBillingSetupResponse {
    return new CompleteBillingSetupResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteBillingSetupResponse {
    return new CompleteBillingSetupResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteBillingSetupResponse {
    return new CompleteBillingSetupResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteBillingSetupResponse | PlainMessage<CompleteBillingSetupResponse> | undefined, b: CompleteBillingSetupResponse | PlainMessage<CompleteBillingSetupResponse> | undefined): boolean {
    return proto3.util.equals(CompleteBillingSetupResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetBillingInfoRequest
 */
export class GetBillingInfoRequest extends Message<GetBillingInfoRequest> {
  /**
   * organization_id is the ID of the organization to get billing info for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetBillingInfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetBillingInfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingInfoRequest {
    return new GetBillingInfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingInfoRequest {
    return new GetBillingInfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingInfoRequest {
    return new GetBillingInfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingInfoRequest | PlainMessage<GetBillingInfoRequest> | undefined, b: GetBillingInfoRequest | PlainMessage<GetBillingInfoRequest> | undefined): boolean {
    return proto3.util.equals(GetBillingInfoRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetBillingInfoResponse
 */
export class GetBillingInfoResponse extends Message<GetBillingInfoResponse> {
  /**
   * total_credits is the total amount of credits granted to the organization
   *
   * @generated from field: double total_credits = 1;
   */
  totalCredits = 0;

  /**
   * available_credits is the remaining credits available for use
   *
   * @generated from field: double available_credits = 2;
   */
  availableCredits = 0;

  /**
   * used_credits is the amount of credits already consumed
   *
   * @generated from field: double used_credits = 3;
   */
  usedCredits = 0;

  /**
   * payment_method_status indicates the status of the payment method
   *
   * @generated from field: gitpod.v1.PaymentMethodStatus payment_method_status = 5;
   */
  paymentMethodStatus = PaymentMethodStatus.UNSPECIFIED;

  /**
   * credit_status indicates the status of the credit balance
   *
   * @generated from field: gitpod.v1.CreditStatus credit_status = 6;
   */
  creditStatus = CreditStatus.UNSPECIFIED;

  /**
   * payment_failure contains information about payment failures if any
   *
   * @generated from field: gitpod.v1.PaymentFailureInfo payment_failure = 10;
   */
  paymentFailure?: PaymentFailureInfo;

  /**
   * topup_payment_failure contains information about topup payment failures if any
   *
   * @generated from field: gitpod.v1.TopupPaymentFailureInfo topup_payment_failure = 11;
   */
  topupPaymentFailure?: TopupPaymentFailureInfo;

  /**
   * auto_topup_settings contains the current auto-topup configuration
   *
   * @generated from field: gitpod.v1.AutoTopupSettings auto_topup_settings = 12;
   */
  autoTopupSettings?: AutoTopupSettings;

  /**
   * last_auto_topup_at is the timestamp of the most recent automatic top-up, if any.
   *
   * @generated from field: google.protobuf.Timestamp last_auto_topup_at = 13;
   */
  lastAutoTopupAt?: Timestamp;

  /**
   * monthly_commitment_cents is the monthly subscription amount in USD cents.
   * 0 means the organization is on a free Core plan. Only set for Core tier organizations
   * with an active contract.
   *
   * @generated from field: int64 monthly_commitment_cents = 14;
   */
  monthlyCommitmentCents = protoInt64.zero;

  /**
   * recovery_credit_granted_at is set when the one-time recovery credit grant has been used.
   * Nil means the organization is still eligible for a recovery credit grant.
   *
   * @generated from field: google.protobuf.Timestamp recovery_credit_granted_at = 15;
   */
  recoveryCreditGrantedAt?: Timestamp;

  /**
   * credit_grant is the contracted credit grant for the organization, in whole credits.
   * Only set for enterprise UBB organizations. 0 means no grant has been configured.
   *
   * @generated from field: int64 credit_grant = 16;
   */
  creditGrant = protoInt64.zero;

  constructor(data?: PartialMessage<GetBillingInfoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetBillingInfoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_credits", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "available_credits", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "used_credits", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "payment_method_status", kind: "enum", T: proto3.getEnumType(PaymentMethodStatus) },
    { no: 6, name: "credit_status", kind: "enum", T: proto3.getEnumType(CreditStatus) },
    { no: 10, name: "payment_failure", kind: "message", T: PaymentFailureInfo },
    { no: 11, name: "topup_payment_failure", kind: "message", T: TopupPaymentFailureInfo },
    { no: 12, name: "auto_topup_settings", kind: "message", T: AutoTopupSettings },
    { no: 13, name: "last_auto_topup_at", kind: "message", T: Timestamp },
    { no: 14, name: "monthly_commitment_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 15, name: "recovery_credit_granted_at", kind: "message", T: Timestamp },
    { no: 16, name: "credit_grant", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingInfoResponse {
    return new GetBillingInfoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingInfoResponse {
    return new GetBillingInfoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingInfoResponse {
    return new GetBillingInfoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingInfoResponse | PlainMessage<GetBillingInfoResponse> | undefined, b: GetBillingInfoResponse | PlainMessage<GetBillingInfoResponse> | undefined): boolean {
    return proto3.util.equals(GetBillingInfoResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ReconcileBillingRequest
 */
export class ReconcileBillingRequest extends Message<ReconcileBillingRequest> {
  /**
   * organization_id is the ID of the organization to reconcile billing for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<ReconcileBillingRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReconcileBillingRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReconcileBillingRequest {
    return new ReconcileBillingRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReconcileBillingRequest {
    return new ReconcileBillingRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReconcileBillingRequest {
    return new ReconcileBillingRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReconcileBillingRequest | PlainMessage<ReconcileBillingRequest> | undefined, b: ReconcileBillingRequest | PlainMessage<ReconcileBillingRequest> | undefined): boolean {
    return proto3.util.equals(ReconcileBillingRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ReconcileBillingResponse
 */
export class ReconcileBillingResponse extends Message<ReconcileBillingResponse> {
  constructor(data?: PartialMessage<ReconcileBillingResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReconcileBillingResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReconcileBillingResponse {
    return new ReconcileBillingResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReconcileBillingResponse {
    return new ReconcileBillingResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReconcileBillingResponse {
    return new ReconcileBillingResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReconcileBillingResponse | PlainMessage<ReconcileBillingResponse> | undefined, b: ReconcileBillingResponse | PlainMessage<ReconcileBillingResponse> | undefined): boolean {
    return proto3.util.equals(ReconcileBillingResponse, a, b);
  }
}

/**
 * TopupPaymentFailureInfo contains information about a failed topup payment
 *
 * @generated from message gitpod.v1.TopupPaymentFailureInfo
 */
export class TopupPaymentFailureInfo extends Message<TopupPaymentFailureInfo> {
  /**
   * failed_at is when the topup payment failure occurred
   *
   * @generated from field: google.protobuf.Timestamp failed_at = 1;
   */
  failedAt?: Timestamp;

  /**
   * error_message describes why the topup payment failed
   *
   * @generated from field: string error_message = 2;
   */
  errorMessage = "";

  constructor(data?: PartialMessage<TopupPaymentFailureInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.TopupPaymentFailureInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "failed_at", kind: "message", T: Timestamp },
    { no: 2, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopupPaymentFailureInfo {
    return new TopupPaymentFailureInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopupPaymentFailureInfo {
    return new TopupPaymentFailureInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopupPaymentFailureInfo {
    return new TopupPaymentFailureInfo().fromJsonString(jsonString, options);
  }

  static equals(a: TopupPaymentFailureInfo | PlainMessage<TopupPaymentFailureInfo> | undefined, b: TopupPaymentFailureInfo | PlainMessage<TopupPaymentFailureInfo> | undefined): boolean {
    return proto3.util.equals(TopupPaymentFailureInfo, a, b);
  }
}

/**
 * @generated from message gitpod.v1.PaymentFailureInfo
 */
export class PaymentFailureInfo extends Message<PaymentFailureInfo> {
  /**
   * state indicates the current state of the payment failure
   *
   * @generated from field: gitpod.v1.PaymentFailureState state = 1;
   */
  state = PaymentFailureState.UNSPECIFIED;

  /**
   * grace_period_ends_at is when the grace period ends
   *
   * @generated from field: google.protobuf.Timestamp grace_period_ends_at = 2;
   */
  gracePeriodEndsAt?: Timestamp;

  /**
   * failed_at is when the payment failure occurred
   *
   * @generated from field: google.protobuf.Timestamp failed_at = 3;
   */
  failedAt?: Timestamp;

  /**
   * failure_reason describes why the payment failed
   *
   * @generated from field: string failure_reason = 4;
   */
  failureReason = "";

  constructor(data?: PartialMessage<PaymentFailureInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PaymentFailureInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "enum", T: proto3.getEnumType(PaymentFailureState) },
    { no: 2, name: "grace_period_ends_at", kind: "message", T: Timestamp },
    { no: 3, name: "failed_at", kind: "message", T: Timestamp },
    { no: 4, name: "failure_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentFailureInfo {
    return new PaymentFailureInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentFailureInfo {
    return new PaymentFailureInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentFailureInfo {
    return new PaymentFailureInfo().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentFailureInfo | PlainMessage<PaymentFailureInfo> | undefined, b: PaymentFailureInfo | PlainMessage<PaymentFailureInfo> | undefined): boolean {
    return proto3.util.equals(PaymentFailureInfo, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateSubscriptionRequest
 */
export class CreateSubscriptionRequest extends Message<CreateSubscriptionRequest> {
  /**
   * organization_id is the ID of the organization to create subscription for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * subscription_type specifies the type of subscription to create
   *
   * @generated from field: gitpod.v1.SubscriptionType subscription_type = 2;
   */
  subscriptionType = SubscriptionType.UNSPECIFIED;

  /**
   * amount_cents is the amount of cents to charge the organization
   *
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents = protoInt64.zero;

  /**
   * coupon_code is the code of the coupon to apply to the subscription
   *
   * @generated from field: string coupon_code = 4;
   */
  couponCode = "";

  constructor(data?: PartialMessage<CreateSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subscription_type", kind: "enum", T: proto3.getEnumType(SubscriptionType) },
    { no: 3, name: "amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSubscriptionRequest {
    return new CreateSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSubscriptionRequest {
    return new CreateSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSubscriptionRequest {
    return new CreateSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSubscriptionRequest | PlainMessage<CreateSubscriptionRequest> | undefined, b: CreateSubscriptionRequest | PlainMessage<CreateSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(CreateSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateSubscriptionResponse
 */
export class CreateSubscriptionResponse extends Message<CreateSubscriptionResponse> {
  /**
   * @generated from field: gitpod.v1.Subscription subscription = 1;
   */
  subscription?: Subscription;

  constructor(data?: PartialMessage<CreateSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription", kind: "message", T: Subscription },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSubscriptionResponse {
    return new CreateSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSubscriptionResponse {
    return new CreateSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSubscriptionResponse {
    return new CreateSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSubscriptionResponse | PlainMessage<CreateSubscriptionResponse> | undefined, b: CreateSubscriptionResponse | PlainMessage<CreateSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(CreateSubscriptionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CancelSubscriptionRequest
 */
export class CancelSubscriptionRequest extends Message<CancelSubscriptionRequest> {
  /**
   * subscription_id is the ID of the subscription to cancel
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * subscription_type specifies the type of subscription to cancel
   *
   * @generated from field: gitpod.v1.SubscriptionType subscription_type = 2;
   */
  subscriptionType = SubscriptionType.UNSPECIFIED;

  constructor(data?: PartialMessage<CancelSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CancelSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subscription_type", kind: "enum", T: proto3.getEnumType(SubscriptionType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelSubscriptionRequest {
    return new CancelSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelSubscriptionRequest {
    return new CancelSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelSubscriptionRequest {
    return new CancelSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CancelSubscriptionRequest | PlainMessage<CancelSubscriptionRequest> | undefined, b: CancelSubscriptionRequest | PlainMessage<CancelSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(CancelSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CancelSubscriptionResponse
 */
export class CancelSubscriptionResponse extends Message<CancelSubscriptionResponse> {
  constructor(data?: PartialMessage<CancelSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CancelSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelSubscriptionResponse {
    return new CancelSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelSubscriptionResponse {
    return new CancelSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelSubscriptionResponse {
    return new CancelSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CancelSubscriptionResponse | PlainMessage<CancelSubscriptionResponse> | undefined, b: CancelSubscriptionResponse | PlainMessage<CancelSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(CancelSubscriptionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateSubscriptionRequest
 */
export class UpdateSubscriptionRequest extends Message<UpdateSubscriptionRequest> {
  /**
   * organization_id is the ID of the organization whose subscription to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * new_amount_cents is the new amount in cents to charge the organization
   *
   * @generated from field: int64 new_amount_cents = 2;
   */
  newAmountCents = protoInt64.zero;

  constructor(data?: PartialMessage<UpdateSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSubscriptionRequest {
    return new UpdateSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSubscriptionRequest {
    return new UpdateSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSubscriptionRequest {
    return new UpdateSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSubscriptionRequest | PlainMessage<UpdateSubscriptionRequest> | undefined, b: UpdateSubscriptionRequest | PlainMessage<UpdateSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateSubscriptionResponse
 */
export class UpdateSubscriptionResponse extends Message<UpdateSubscriptionResponse> {
  /**
   * @generated from field: gitpod.v1.Subscription subscription = 1;
   */
  subscription?: Subscription;

  constructor(data?: PartialMessage<UpdateSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription", kind: "message", T: Subscription },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSubscriptionResponse {
    return new UpdateSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSubscriptionResponse {
    return new UpdateSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSubscriptionResponse {
    return new UpdateSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSubscriptionResponse | PlainMessage<UpdateSubscriptionResponse> | undefined, b: UpdateSubscriptionResponse | PlainMessage<UpdateSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateSubscriptionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSubscriptionsRequest
 */
export class ListSubscriptionsRequest extends Message<ListSubscriptionsRequest> {
  /**
   * organization_id is the ID of the organization to list subscriptions for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<ListSubscriptionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSubscriptionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSubscriptionsRequest {
    return new ListSubscriptionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSubscriptionsRequest {
    return new ListSubscriptionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSubscriptionsRequest {
    return new ListSubscriptionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSubscriptionsRequest | PlainMessage<ListSubscriptionsRequest> | undefined, b: ListSubscriptionsRequest | PlainMessage<ListSubscriptionsRequest> | undefined): boolean {
    return proto3.util.equals(ListSubscriptionsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.Subscription
 */
export class Subscription extends Message<Subscription> {
  /**
   * contract_id is the unique identifier for the contract
   *
   * @generated from field: string contract_id = 1;
   */
  contractId = "";

  /**
   * organization_id is the ID of the organization that owns the subscription
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  /**
   * subscription_type is the type of subscription
   *
   * @generated from field: gitpod.v1.SubscriptionType subscription_type = 3;
   */
  subscriptionType = SubscriptionType.UNSPECIFIED;

  /**
   * status is the current status of the subscription
   *
   * @generated from field: gitpod.v1.SubscriptionStatus status = 4;
   */
  status = SubscriptionStatus.UNSPECIFIED;

  /**
   * starts_at is when the subscription was created
   *
   * @generated from field: google.protobuf.Timestamp starts_at = 6;
   */
  startsAt?: Timestamp;

  /**
   * cancelled_at is when the subscription was cancelled (if applicable)
   *
   * @generated from field: google.protobuf.Timestamp cancelled_at = 7;
   */
  cancelledAt?: Timestamp;

  /**
   * ends_at is when the subscription access will end (if cancelled)
   *
   * @generated from field: google.protobuf.Timestamp ends_at = 9;
   */
  endsAt?: Timestamp;

  constructor(data?: PartialMessage<Subscription>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Subscription";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contract_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subscription_type", kind: "enum", T: proto3.getEnumType(SubscriptionType) },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(SubscriptionStatus) },
    { no: 6, name: "starts_at", kind: "message", T: Timestamp },
    { no: 7, name: "cancelled_at", kind: "message", T: Timestamp },
    { no: 9, name: "ends_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Subscription {
    return new Subscription().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Subscription {
    return new Subscription().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Subscription {
    return new Subscription().fromJsonString(jsonString, options);
  }

  static equals(a: Subscription | PlainMessage<Subscription> | undefined, b: Subscription | PlainMessage<Subscription> | undefined): boolean {
    return proto3.util.equals(Subscription, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSubscriptionsResponse
 */
export class ListSubscriptionsResponse extends Message<ListSubscriptionsResponse> {
  /**
   * subscriptions is the list of subscriptions for the organization
   *
   * @generated from field: repeated gitpod.v1.Subscription subscriptions = 1;
   */
  subscriptions: Subscription[] = [];

  constructor(data?: PartialMessage<ListSubscriptionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSubscriptionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscriptions", kind: "message", T: Subscription, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSubscriptionsResponse {
    return new ListSubscriptionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSubscriptionsResponse {
    return new ListSubscriptionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSubscriptionsResponse {
    return new ListSubscriptionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSubscriptionsResponse | PlainMessage<ListSubscriptionsResponse> | undefined, b: ListSubscriptionsResponse | PlainMessage<ListSubscriptionsResponse> | undefined): boolean {
    return proto3.util.equals(ListSubscriptionsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GrantCreditsRequest
 */
export class GrantCreditsRequest extends Message<GrantCreditsRequest> {
  /**
   * organization_id is the ID of the organization to grant credits to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * credits_amount is the amount of credits to grant (must be >= 40)
   *
   * @generated from field: double credits_amount = 2;
   */
  creditsAmount = 0;

  constructor(data?: PartialMessage<GrantCreditsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GrantCreditsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "credits_amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GrantCreditsRequest {
    return new GrantCreditsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GrantCreditsRequest {
    return new GrantCreditsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GrantCreditsRequest {
    return new GrantCreditsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GrantCreditsRequest | PlainMessage<GrantCreditsRequest> | undefined, b: GrantCreditsRequest | PlainMessage<GrantCreditsRequest> | undefined): boolean {
    return proto3.util.equals(GrantCreditsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GrantCreditsResponse
 */
export class GrantCreditsResponse extends Message<GrantCreditsResponse> {
  constructor(data?: PartialMessage<GrantCreditsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GrantCreditsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GrantCreditsResponse {
    return new GrantCreditsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GrantCreditsResponse {
    return new GrantCreditsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GrantCreditsResponse {
    return new GrantCreditsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GrantCreditsResponse | PlainMessage<GrantCreditsResponse> | undefined, b: GrantCreditsResponse | PlainMessage<GrantCreditsResponse> | undefined): boolean {
    return proto3.util.equals(GrantCreditsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetStripePublishableKeyRequest
 */
export class GetStripePublishableKeyRequest extends Message<GetStripePublishableKeyRequest> {
  /**
   * organization_id is the ID of the organization to get the publishable key for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetStripePublishableKeyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetStripePublishableKeyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStripePublishableKeyRequest {
    return new GetStripePublishableKeyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStripePublishableKeyRequest {
    return new GetStripePublishableKeyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStripePublishableKeyRequest {
    return new GetStripePublishableKeyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStripePublishableKeyRequest | PlainMessage<GetStripePublishableKeyRequest> | undefined, b: GetStripePublishableKeyRequest | PlainMessage<GetStripePublishableKeyRequest> | undefined): boolean {
    return proto3.util.equals(GetStripePublishableKeyRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetStripePublishableKeyResponse
 */
export class GetStripePublishableKeyResponse extends Message<GetStripePublishableKeyResponse> {
  /**
   * publishable_key is the Stripe publishable key for the organization's billing realm
   *
   * @generated from field: string publishable_key = 1;
   */
  publishableKey = "";

  constructor(data?: PartialMessage<GetStripePublishableKeyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetStripePublishableKeyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "publishable_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStripePublishableKeyResponse {
    return new GetStripePublishableKeyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStripePublishableKeyResponse {
    return new GetStripePublishableKeyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStripePublishableKeyResponse {
    return new GetStripePublishableKeyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStripePublishableKeyResponse | PlainMessage<GetStripePublishableKeyResponse> | undefined, b: GetStripePublishableKeyResponse | PlainMessage<GetStripePublishableKeyResponse> | undefined): boolean {
    return proto3.util.equals(GetStripePublishableKeyResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetBillingRealmRequest
 */
export class SetBillingRealmRequest extends Message<SetBillingRealmRequest> {
  /**
   * organization_id is the ID of the organization to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * realm is the new billing realm to set for the organization
   *
   * @generated from field: gitpod.v1.BillingRealm realm = 2;
   */
  realm = BillingRealm.UNSPECIFIED;

  constructor(data?: PartialMessage<SetBillingRealmRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetBillingRealmRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "realm", kind: "enum", T: proto3.getEnumType(BillingRealm) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetBillingRealmRequest {
    return new SetBillingRealmRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetBillingRealmRequest {
    return new SetBillingRealmRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetBillingRealmRequest {
    return new SetBillingRealmRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetBillingRealmRequest | PlainMessage<SetBillingRealmRequest> | undefined, b: SetBillingRealmRequest | PlainMessage<SetBillingRealmRequest> | undefined): boolean {
    return proto3.util.equals(SetBillingRealmRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetBillingRealmResponse
 */
export class SetBillingRealmResponse extends Message<SetBillingRealmResponse> {
  constructor(data?: PartialMessage<SetBillingRealmResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetBillingRealmResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetBillingRealmResponse {
    return new SetBillingRealmResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetBillingRealmResponse {
    return new SetBillingRealmResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetBillingRealmResponse {
    return new SetBillingRealmResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetBillingRealmResponse | PlainMessage<SetBillingRealmResponse> | undefined, b: SetBillingRealmResponse | PlainMessage<SetBillingRealmResponse> | undefined): boolean {
    return proto3.util.equals(SetBillingRealmResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateCardVerificationRequest
 */
export class CreateCardVerificationRequest extends Message<CreateCardVerificationRequest> {
  /**
   * email is the exact email address of the account
   *
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * organization_id is the specific organization to verify (required if user has multiple orgs or already has a verified org)
   *
   * @generated from field: optional string organization_id = 2;
   */
  organizationId?: string;

  /**
   * reason is an optional description of why this email is being approved
   * (e.g., "Ona for Open Source - Project X")
   *
   * @generated from field: optional string reason = 3;
   */
  reason?: string;

  /**
   * free_credits is the number of free credits to grant when the user's Core
   * subscription is provisioned. If zero or unset, the default amount is used.
   *
   * @generated from field: optional int32 free_credits = 4;
   */
  freeCredits?: number;

  constructor(data?: PartialMessage<CreateCardVerificationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateCardVerificationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "free_credits", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCardVerificationRequest {
    return new CreateCardVerificationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCardVerificationRequest {
    return new CreateCardVerificationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCardVerificationRequest {
    return new CreateCardVerificationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCardVerificationRequest | PlainMessage<CreateCardVerificationRequest> | undefined, b: CreateCardVerificationRequest | PlainMessage<CreateCardVerificationRequest> | undefined): boolean {
    return proto3.util.equals(CreateCardVerificationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateCardVerificationResponse
 */
export class CreateCardVerificationResponse extends Message<CreateCardVerificationResponse> {
  constructor(data?: PartialMessage<CreateCardVerificationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateCardVerificationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCardVerificationResponse {
    return new CreateCardVerificationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCardVerificationResponse {
    return new CreateCardVerificationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCardVerificationResponse {
    return new CreateCardVerificationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCardVerificationResponse | PlainMessage<CreateCardVerificationResponse> | undefined, b: CreateCardVerificationResponse | PlainMessage<CreateCardVerificationResponse> | undefined): boolean {
    return proto3.util.equals(CreateCardVerificationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetTaxIDRequest
 */
export class SetTaxIDRequest extends Message<SetTaxIDRequest> {
  /**
   * organization_id is the ID of the organization to set tax ID for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * tax_id_type is the type of tax ID (e.g., "eu_vat", "us_ein", "gb_vat")
   *
   * @generated from field: string tax_id_type = 2;
   */
  taxIdType = "";

  /**
   * tax_id_value is the tax ID value
   *
   * @generated from field: string tax_id_value = 3;
   */
  taxIdValue = "";

  constructor(data?: PartialMessage<SetTaxIDRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetTaxIDRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tax_id_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tax_id_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetTaxIDRequest {
    return new SetTaxIDRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetTaxIDRequest {
    return new SetTaxIDRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetTaxIDRequest {
    return new SetTaxIDRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetTaxIDRequest | PlainMessage<SetTaxIDRequest> | undefined, b: SetTaxIDRequest | PlainMessage<SetTaxIDRequest> | undefined): boolean {
    return proto3.util.equals(SetTaxIDRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetTaxIDResponse
 */
export class SetTaxIDResponse extends Message<SetTaxIDResponse> {
  constructor(data?: PartialMessage<SetTaxIDResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetTaxIDResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetTaxIDResponse {
    return new SetTaxIDResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetTaxIDResponse {
    return new SetTaxIDResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetTaxIDResponse {
    return new SetTaxIDResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetTaxIDResponse | PlainMessage<SetTaxIDResponse> | undefined, b: SetTaxIDResponse | PlainMessage<SetTaxIDResponse> | undefined): boolean {
    return proto3.util.equals(SetTaxIDResponse, a, b);
  }
}

/**
 * Coupon represents a promotional code that can be redeemed for credits
 *
 * @generated from message gitpod.v1.Coupon
 */
export class Coupon extends Message<Coupon> {
  /**
   * id is the unique identifier for the coupon
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * code is the unique coupon code that customers can redeem
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * config is the configuration for this coupon
   *
   * @generated from field: gitpod.v1.CouponConfig config = 3;
   */
  config?: CouponConfig;

  /**
   * max_uses is the maximum number of times this coupon can be redeemed
   *
   * @generated from field: int32 max_uses = 4;
   */
  maxUses = 0;

  /**
   * max_uses_per_org is the maximum number of times this coupon can be redeemed per organization
   *
   * @generated from field: optional int32 max_uses_per_org = 5;
   */
  maxUsesPerOrg?: number;

  /**
   * expires_at is when this coupon expires (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp;

  /**
   * description is a human-readable description of the coupon
   *
   * @generated from field: optional string description = 7;
   */
  description?: string;

  /**
   * created_at is when the coupon was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the coupon was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<Coupon>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Coupon";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "config", kind: "message", T: CouponConfig },
    { no: 4, name: "max_uses", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "max_uses_per_org", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "expires_at", kind: "message", T: Timestamp, opt: true },
    { no: 7, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
    { no: 9, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Coupon {
    return new Coupon().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Coupon {
    return new Coupon().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Coupon {
    return new Coupon().fromJsonString(jsonString, options);
  }

  static equals(a: Coupon | PlainMessage<Coupon> | undefined, b: Coupon | PlainMessage<Coupon> | undefined): boolean {
    return proto3.util.equals(Coupon, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateCouponRequest
 */
export class CreateCouponRequest extends Message<CreateCouponRequest> {
  /**
   * code is the unique coupon code that customers will redeem
   *
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * config is the configuration for this coupon
   *
   * @generated from field: gitpod.v1.CouponConfig config = 2;
   */
  config?: CouponConfig;

  /**
   * max_uses is the maximum number of times this coupon can be redeemed
   *
   * @generated from field: int32 max_uses = 3;
   */
  maxUses = 0;

  /**
   * max_uses_per_org is the maximum number of times this coupon can be redeemed per organization
   *
   * @generated from field: optional int32 max_uses_per_org = 4;
   */
  maxUsesPerOrg?: number;

  /**
   * expires_at is when this coupon expires (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp expires_at = 5;
   */
  expiresAt?: Timestamp;

  /**
   * description is a human-readable description of the coupon
   *
   * @generated from field: optional string description = 6;
   */
  description?: string;

  constructor(data?: PartialMessage<CreateCouponRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateCouponRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "config", kind: "message", T: CouponConfig },
    { no: 3, name: "max_uses", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "max_uses_per_org", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "expires_at", kind: "message", T: Timestamp, opt: true },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCouponRequest {
    return new CreateCouponRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCouponRequest {
    return new CreateCouponRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCouponRequest {
    return new CreateCouponRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCouponRequest | PlainMessage<CreateCouponRequest> | undefined, b: CreateCouponRequest | PlainMessage<CreateCouponRequest> | undefined): boolean {
    return proto3.util.equals(CreateCouponRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CouponConfig
 */
export class CouponConfig extends Message<CouponConfig> {
  /**
   * one_time_ocu_grant is the amount of OCU this coupon grants
   *
   * @generated from field: optional int64 one_time_ocu_grant = 1;
   */
  oneTimeOcuGrant?: bigint;

  /**
   * percentage_off is the percentage off this coupon grants
   *
   * @generated from field: optional int64 percentage_off = 2;
   */
  percentageOff?: bigint;

  /**
   * duration_months is the duration of the coupon in months
   *
   * @generated from field: optional int64 duration_months = 3;
   */
  durationMonths?: bigint;

  /**
   * auto_terminate is whether the subscription should be terminated after the duration has passed
   *
   * @generated from field: bool auto_terminate = 4;
   */
  autoTerminate = false;

  constructor(data?: PartialMessage<CouponConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CouponConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "one_time_ocu_grant", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "percentage_off", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "duration_months", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "auto_terminate", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CouponConfig {
    return new CouponConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CouponConfig {
    return new CouponConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CouponConfig {
    return new CouponConfig().fromJsonString(jsonString, options);
  }

  static equals(a: CouponConfig | PlainMessage<CouponConfig> | undefined, b: CouponConfig | PlainMessage<CouponConfig> | undefined): boolean {
    return proto3.util.equals(CouponConfig, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateCouponResponse
 */
export class CreateCouponResponse extends Message<CreateCouponResponse> {
  /**
   * @generated from field: gitpod.v1.Coupon coupon = 1;
   */
  coupon?: Coupon;

  constructor(data?: PartialMessage<CreateCouponResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateCouponResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "coupon", kind: "message", T: Coupon },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCouponResponse {
    return new CreateCouponResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCouponResponse {
    return new CreateCouponResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCouponResponse {
    return new CreateCouponResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCouponResponse | PlainMessage<CreateCouponResponse> | undefined, b: CreateCouponResponse | PlainMessage<CreateCouponResponse> | undefined): boolean {
    return proto3.util.equals(CreateCouponResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListCouponsRequest
 */
export class ListCouponsRequest extends Message<ListCouponsRequest> {
  /**
   * pagination contains the pagination options for listing coupons
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListCouponsRequest.Filter filter = 2;
   */
  filter?: ListCouponsRequest_Filter;

  constructor(data?: PartialMessage<ListCouponsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListCouponsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListCouponsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCouponsRequest {
    return new ListCouponsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCouponsRequest {
    return new ListCouponsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCouponsRequest {
    return new ListCouponsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCouponsRequest | PlainMessage<ListCouponsRequest> | undefined, b: ListCouponsRequest | PlainMessage<ListCouponsRequest> | undefined): boolean {
    return proto3.util.equals(ListCouponsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListCouponsRequest.Filter
 */
export class ListCouponsRequest_Filter extends Message<ListCouponsRequest_Filter> {
  /**
   * coupon_ids filters the response to only coupons with these IDs
   *
   * @generated from field: repeated string coupon_ids = 1;
   */
  couponIds: string[] = [];

  /**
   * code filters coupons by exact code match
   *
   * @generated from field: optional string code = 4;
   */
  code?: string;

  /**
   * expires_before filters coupons that expire before this timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp expires_before = 5;
   */
  expiresBefore?: Timestamp;

  /**
   * expires_after filters coupons that expire after this timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp expires_after = 6;
   */
  expiresAfter?: Timestamp;

  constructor(data?: PartialMessage<ListCouponsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListCouponsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "coupon_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "expires_before", kind: "message", T: Timestamp, opt: true },
    { no: 6, name: "expires_after", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCouponsRequest_Filter {
    return new ListCouponsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCouponsRequest_Filter {
    return new ListCouponsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCouponsRequest_Filter {
    return new ListCouponsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListCouponsRequest_Filter | PlainMessage<ListCouponsRequest_Filter> | undefined, b: ListCouponsRequest_Filter | PlainMessage<ListCouponsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListCouponsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListCouponsResponse
 */
export class ListCouponsResponse extends Message<ListCouponsResponse> {
  /**
   * pagination contains the pagination response
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Coupon coupons = 2;
   */
  coupons: Coupon[] = [];

  constructor(data?: PartialMessage<ListCouponsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListCouponsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "coupons", kind: "message", T: Coupon, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCouponsResponse {
    return new ListCouponsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCouponsResponse {
    return new ListCouponsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCouponsResponse {
    return new ListCouponsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCouponsResponse | PlainMessage<ListCouponsResponse> | undefined, b: ListCouponsResponse | PlainMessage<ListCouponsResponse> | undefined): boolean {
    return proto3.util.equals(ListCouponsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCouponRequest
 */
export class GetCouponRequest extends Message<GetCouponRequest> {
  /**
   * coupon_code is the code of the coupon to retrieve
   *
   * @generated from field: string coupon_code = 1;
   */
  couponCode = "";

  /**
   * organization_id is the organization context for per-organization validation
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetCouponRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCouponRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCouponRequest {
    return new GetCouponRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCouponRequest {
    return new GetCouponRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCouponRequest {
    return new GetCouponRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCouponRequest | PlainMessage<GetCouponRequest> | undefined, b: GetCouponRequest | PlainMessage<GetCouponRequest> | undefined): boolean {
    return proto3.util.equals(GetCouponRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCouponResponse
 */
export class GetCouponResponse extends Message<GetCouponResponse> {
  /**
   * @generated from field: gitpod.v1.Coupon coupon = 1;
   */
  coupon?: Coupon;

  constructor(data?: PartialMessage<GetCouponResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCouponResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "coupon", kind: "message", T: Coupon },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCouponResponse {
    return new GetCouponResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCouponResponse {
    return new GetCouponResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCouponResponse {
    return new GetCouponResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCouponResponse | PlainMessage<GetCouponResponse> | undefined, b: GetCouponResponse | PlainMessage<GetCouponResponse> | undefined): boolean {
    return proto3.util.equals(GetCouponResponse, a, b);
  }
}

/**
 * BillingAddress represents a billing address for an organization
 *
 * @generated from message gitpod.v1.BillingAddress
 */
export class BillingAddress extends Message<BillingAddress> {
  /**
   * line1 is the first line of the address (street address)
   *
   * @generated from field: string line1 = 1;
   */
  line1 = "";

  /**
   * line2 is the second line of the address (apartment, suite, etc.)
   *
   * @generated from field: string line2 = 2;
   */
  line2 = "";

  /**
   * city is the city name
   *
   * @generated from field: string city = 3;
   */
  city = "";

  /**
   * state is the state or province
   *
   * @generated from field: string state = 4;
   */
  state = "";

  /**
   * postal_code is the postal or ZIP code
   *
   * @generated from field: string postal_code = 5;
   */
  postalCode = "";

  /**
   * country is the two-letter country code (ISO 3166-1 alpha-2)
   *
   * @generated from field: string country = 6;
   */
  country = "";

  constructor(data?: PartialMessage<BillingAddress>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.BillingAddress";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "line1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "line2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BillingAddress {
    return new BillingAddress().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BillingAddress {
    return new BillingAddress().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BillingAddress {
    return new BillingAddress().fromJsonString(jsonString, options);
  }

  static equals(a: BillingAddress | PlainMessage<BillingAddress> | undefined, b: BillingAddress | PlainMessage<BillingAddress> | undefined): boolean {
    return proto3.util.equals(BillingAddress, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetBillingAddressRequest
 */
export class SetBillingAddressRequest extends Message<SetBillingAddressRequest> {
  /**
   * organization_id is the ID of the organization to set billing address for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * name is the name associated with the billing address
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * address is the billing address details
   *
   * @generated from field: gitpod.v1.BillingAddress address = 3;
   */
  address?: BillingAddress;

  constructor(data?: PartialMessage<SetBillingAddressRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetBillingAddressRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "address", kind: "message", T: BillingAddress },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetBillingAddressRequest {
    return new SetBillingAddressRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetBillingAddressRequest {
    return new SetBillingAddressRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetBillingAddressRequest {
    return new SetBillingAddressRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetBillingAddressRequest | PlainMessage<SetBillingAddressRequest> | undefined, b: SetBillingAddressRequest | PlainMessage<SetBillingAddressRequest> | undefined): boolean {
    return proto3.util.equals(SetBillingAddressRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetBillingAddressResponse
 */
export class SetBillingAddressResponse extends Message<SetBillingAddressResponse> {
  constructor(data?: PartialMessage<SetBillingAddressResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetBillingAddressResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetBillingAddressResponse {
    return new SetBillingAddressResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetBillingAddressResponse {
    return new SetBillingAddressResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetBillingAddressResponse {
    return new SetBillingAddressResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetBillingAddressResponse | PlainMessage<SetBillingAddressResponse> | undefined, b: SetBillingAddressResponse | PlainMessage<SetBillingAddressResponse> | undefined): boolean {
    return proto3.util.equals(SetBillingAddressResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetStripePortalUrlRequest
 */
export class GetStripePortalUrlRequest extends Message<GetStripePortalUrlRequest> {
  /**
   * organization_id is the ID of the organization to get the Stripe portal URL for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetStripePortalUrlRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetStripePortalUrlRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStripePortalUrlRequest {
    return new GetStripePortalUrlRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStripePortalUrlRequest {
    return new GetStripePortalUrlRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStripePortalUrlRequest {
    return new GetStripePortalUrlRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStripePortalUrlRequest | PlainMessage<GetStripePortalUrlRequest> | undefined, b: GetStripePortalUrlRequest | PlainMessage<GetStripePortalUrlRequest> | undefined): boolean {
    return proto3.util.equals(GetStripePortalUrlRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetStripePortalUrlResponse
 */
export class GetStripePortalUrlResponse extends Message<GetStripePortalUrlResponse> {
  /**
   * portal_url is the URL to the Stripe Customer Portal for billing management
   *
   * @generated from field: string portal_url = 1;
   */
  portalUrl = "";

  constructor(data?: PartialMessage<GetStripePortalUrlResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetStripePortalUrlResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "portal_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStripePortalUrlResponse {
    return new GetStripePortalUrlResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStripePortalUrlResponse {
    return new GetStripePortalUrlResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStripePortalUrlResponse {
    return new GetStripePortalUrlResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStripePortalUrlResponse | PlainMessage<GetStripePortalUrlResponse> | undefined, b: GetStripePortalUrlResponse | PlainMessage<GetStripePortalUrlResponse> | undefined): boolean {
    return proto3.util.equals(GetStripePortalUrlResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ClearTopupFailureRequest
 */
export class ClearTopupFailureRequest extends Message<ClearTopupFailureRequest> {
  /**
   * organization_id is the ID of the organization to clear the topup failure for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<ClearTopupFailureRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ClearTopupFailureRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearTopupFailureRequest {
    return new ClearTopupFailureRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearTopupFailureRequest {
    return new ClearTopupFailureRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearTopupFailureRequest {
    return new ClearTopupFailureRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ClearTopupFailureRequest | PlainMessage<ClearTopupFailureRequest> | undefined, b: ClearTopupFailureRequest | PlainMessage<ClearTopupFailureRequest> | undefined): boolean {
    return proto3.util.equals(ClearTopupFailureRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ClearTopupFailureResponse
 */
export class ClearTopupFailureResponse extends Message<ClearTopupFailureResponse> {
  constructor(data?: PartialMessage<ClearTopupFailureResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ClearTopupFailureResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearTopupFailureResponse {
    return new ClearTopupFailureResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearTopupFailureResponse {
    return new ClearTopupFailureResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearTopupFailureResponse {
    return new ClearTopupFailureResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ClearTopupFailureResponse | PlainMessage<ClearTopupFailureResponse> | undefined, b: ClearTopupFailureResponse | PlainMessage<ClearTopupFailureResponse> | undefined): boolean {
    return proto3.util.equals(ClearTopupFailureResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCreditConsumptionTimeSeriesRequest
 */
export class GetCreditConsumptionTimeSeriesRequest extends Message<GetCreditConsumptionTimeSeriesRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * Date range for the consumption query. Optional; defaults to the last 7 days.
   * The range must not exceed 30 days, and end_time must not be in the future.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 3;
   */
  dateRange?: DateRange;

  constructor(data?: PartialMessage<GetCreditConsumptionTimeSeriesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCreditConsumptionTimeSeriesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "date_range", kind: "message", T: DateRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditConsumptionTimeSeriesRequest {
    return new GetCreditConsumptionTimeSeriesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditConsumptionTimeSeriesRequest {
    return new GetCreditConsumptionTimeSeriesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditConsumptionTimeSeriesRequest {
    return new GetCreditConsumptionTimeSeriesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditConsumptionTimeSeriesRequest | PlainMessage<GetCreditConsumptionTimeSeriesRequest> | undefined, b: GetCreditConsumptionTimeSeriesRequest | PlainMessage<GetCreditConsumptionTimeSeriesRequest> | undefined): boolean {
    return proto3.util.equals(GetCreditConsumptionTimeSeriesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCreditConsumptionTimeSeriesResponse
 */
export class GetCreditConsumptionTimeSeriesResponse extends Message<GetCreditConsumptionTimeSeriesResponse> {
  /**
   * Per-metric OCU consumption time series, plus a total entry with kind ALL.
   *
   * @generated from field: repeated gitpod.v1.MetricConsumptionTimeSeries metrics = 1;
   */
  metrics: MetricConsumptionTimeSeries[] = [];

  constructor(data?: PartialMessage<GetCreditConsumptionTimeSeriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCreditConsumptionTimeSeriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "metrics", kind: "message", T: MetricConsumptionTimeSeries, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditConsumptionTimeSeriesResponse {
    return new GetCreditConsumptionTimeSeriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditConsumptionTimeSeriesResponse {
    return new GetCreditConsumptionTimeSeriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditConsumptionTimeSeriesResponse {
    return new GetCreditConsumptionTimeSeriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditConsumptionTimeSeriesResponse | PlainMessage<GetCreditConsumptionTimeSeriesResponse> | undefined, b: GetCreditConsumptionTimeSeriesResponse | PlainMessage<GetCreditConsumptionTimeSeriesResponse> | undefined): boolean {
    return proto3.util.equals(GetCreditConsumptionTimeSeriesResponse, a, b);
  }
}

/**
 * Daily OCU consumption for a single metric category.
 *
 * @generated from message gitpod.v1.MetricConsumptionTimeSeries
 */
export class MetricConsumptionTimeSeries extends Message<MetricConsumptionTimeSeries> {
  /**
   * Human-readable label (e.g. "Environment Usage", "LLM Cache Reads", "Total").
   *
   * @generated from field: string display_name = 1;
   */
  displayName = "";

  /**
   * Category for grouping and filtering.
   *
   * @generated from field: gitpod.v1.MetricConsumptionTimeSeries.Kind kind = 2;
   */
  kind = MetricConsumptionTimeSeries_Kind.UNSPECIFIED;

  /**
   * Daily data points.
   *
   * @generated from field: repeated gitpod.v1.CreditUsageDataPoint series = 3;
   */
  series: CreditUsageDataPoint[] = [];

  constructor(data?: PartialMessage<MetricConsumptionTimeSeries>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.MetricConsumptionTimeSeries";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kind", kind: "enum", T: proto3.getEnumType(MetricConsumptionTimeSeries_Kind) },
    { no: 3, name: "series", kind: "message", T: CreditUsageDataPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MetricConsumptionTimeSeries {
    return new MetricConsumptionTimeSeries().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MetricConsumptionTimeSeries {
    return new MetricConsumptionTimeSeries().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MetricConsumptionTimeSeries {
    return new MetricConsumptionTimeSeries().fromJsonString(jsonString, options);
  }

  static equals(a: MetricConsumptionTimeSeries | PlainMessage<MetricConsumptionTimeSeries> | undefined, b: MetricConsumptionTimeSeries | PlainMessage<MetricConsumptionTimeSeries> | undefined): boolean {
    return proto3.util.equals(MetricConsumptionTimeSeries, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.MetricConsumptionTimeSeries.Kind
 */
export enum MetricConsumptionTimeSeries_Kind {
  /**
   * @generated from enum value: KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: KIND_ALL = 1;
   */
  ALL = 1,

  /**
   * @generated from enum value: KIND_ENVIRONMENT = 2;
   */
  ENVIRONMENT = 2,

  /**
   * @generated from enum value: KIND_LLM = 3;
   */
  LLM = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(MetricConsumptionTimeSeries_Kind)
proto3.util.setEnumType(MetricConsumptionTimeSeries_Kind, "gitpod.v1.MetricConsumptionTimeSeries.Kind", [
  { no: 0, name: "KIND_UNSPECIFIED" },
  { no: 1, name: "KIND_ALL" },
  { no: 2, name: "KIND_ENVIRONMENT" },
  { no: 3, name: "KIND_LLM" },
]);

/**
 * A single data point in a credit consumption time series.
 *
 * @generated from message gitpod.v1.CreditUsageDataPoint
 */
export class CreditUsageDataPoint extends Message<CreditUsageDataPoint> {
  /**
   * Start of the day (UTC midnight).
   *
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * Cost in Ona Compute Units.
   *
   * @generated from field: double ocu = 2;
   */
  ocu = 0;

  constructor(data?: PartialMessage<CreditUsageDataPoint>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreditUsageDataPoint";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "time", kind: "message", T: Timestamp },
    { no: 2, name: "ocu", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditUsageDataPoint {
    return new CreditUsageDataPoint().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditUsageDataPoint {
    return new CreditUsageDataPoint().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditUsageDataPoint {
    return new CreditUsageDataPoint().fromJsonString(jsonString, options);
  }

  static equals(a: CreditUsageDataPoint | PlainMessage<CreditUsageDataPoint> | undefined, b: CreditUsageDataPoint | PlainMessage<CreditUsageDataPoint> | undefined): boolean {
    return proto3.util.equals(CreditUsageDataPoint, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetupEnterpriseBillingRequest
 */
export class SetupEnterpriseBillingRequest extends Message<SetupEnterpriseBillingRequest> {
  /**
   * organization_id is the ID of the organization to set up enterprise billing for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * sandbox selects the sandbox billing environment. If false or unset, production is used.
   *
   * @generated from field: bool sandbox = 2;
   */
  sandbox = false;

  /**
   * set_enterprise_tier also sets the organization tier to Enterprise.
   * If false or unset, the organization must already be on Enterprise tier.
   *
   * @generated from field: bool set_enterprise_tier = 3;
   */
  setEnterpriseTier = false;

  /**
   * email is the email address for the Stripe customer (optional)
   *
   * @generated from field: optional string email = 4;
   */
  email?: string;

  /**
   * contract_start_date is the date from which usage data should be shown/exported.
   * Usage events before this date are still recorded but excluded from reports and Stripe sync.
   *
   * @generated from field: optional google.protobuf.Timestamp contract_start_date = 5;
   */
  contractStartDate?: Timestamp;

  constructor(data?: PartialMessage<SetupEnterpriseBillingRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetupEnterpriseBillingRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sandbox", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "set_enterprise_tier", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "contract_start_date", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetupEnterpriseBillingRequest {
    return new SetupEnterpriseBillingRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetupEnterpriseBillingRequest {
    return new SetupEnterpriseBillingRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetupEnterpriseBillingRequest {
    return new SetupEnterpriseBillingRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetupEnterpriseBillingRequest | PlainMessage<SetupEnterpriseBillingRequest> | undefined, b: SetupEnterpriseBillingRequest | PlainMessage<SetupEnterpriseBillingRequest> | undefined): boolean {
    return proto3.util.equals(SetupEnterpriseBillingRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetupEnterpriseBillingResponse
 */
export class SetupEnterpriseBillingResponse extends Message<SetupEnterpriseBillingResponse> {
  /**
   * stripe_customer_id is the created or existing Stripe customer ID
   *
   * @generated from field: string stripe_customer_id = 1;
   */
  stripeCustomerId = "";

  constructor(data?: PartialMessage<SetupEnterpriseBillingResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetupEnterpriseBillingResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stripe_customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetupEnterpriseBillingResponse {
    return new SetupEnterpriseBillingResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetupEnterpriseBillingResponse {
    return new SetupEnterpriseBillingResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetupEnterpriseBillingResponse {
    return new SetupEnterpriseBillingResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetupEnterpriseBillingResponse | PlainMessage<SetupEnterpriseBillingResponse> | undefined, b: SetupEnterpriseBillingResponse | PlainMessage<SetupEnterpriseBillingResponse> | undefined): boolean {
    return proto3.util.equals(SetupEnterpriseBillingResponse, a, b);
  }
}

/**
 * AutoTopupSettings configures automatic credit top-ups for an organization.
 *
 * @generated from message gitpod.v1.AutoTopupSettings
 */
export class AutoTopupSettings extends Message<AutoTopupSettings> {
  /**
   * Whether auto-topup is enabled.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled = false;

  /**
   * OCU amount per top-up. Must be one of: 40, 100, 200, 400, 1000.
   *
   * @generated from field: double amount_credits = 2;
   */
  amountCredits = 0;

  /**
   * Maximum number of automatic top-ups per day (safety cap, 0 means no cap).
   *
   * @generated from field: int32 max_daily_topups = 3;
   */
  maxDailyTopups = 0;

  constructor(data?: PartialMessage<AutoTopupSettings>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AutoTopupSettings";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "amount_credits", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "max_daily_topups", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AutoTopupSettings {
    return new AutoTopupSettings().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AutoTopupSettings {
    return new AutoTopupSettings().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AutoTopupSettings {
    return new AutoTopupSettings().fromJsonString(jsonString, options);
  }

  static equals(a: AutoTopupSettings | PlainMessage<AutoTopupSettings> | undefined, b: AutoTopupSettings | PlainMessage<AutoTopupSettings> | undefined): boolean {
    return proto3.util.equals(AutoTopupSettings, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAutoTopupSettingsRequest
 */
export class UpdateAutoTopupSettingsRequest extends Message<UpdateAutoTopupSettingsRequest> {
  /**
   * organization_id is the ID of the organization to update auto-topup settings for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * settings contains the new auto-topup configuration
   *
   * @generated from field: gitpod.v1.AutoTopupSettings settings = 2;
   */
  settings?: AutoTopupSettings;

  constructor(data?: PartialMessage<UpdateAutoTopupSettingsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAutoTopupSettingsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "settings", kind: "message", T: AutoTopupSettings },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAutoTopupSettingsRequest {
    return new UpdateAutoTopupSettingsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAutoTopupSettingsRequest {
    return new UpdateAutoTopupSettingsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAutoTopupSettingsRequest {
    return new UpdateAutoTopupSettingsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAutoTopupSettingsRequest | PlainMessage<UpdateAutoTopupSettingsRequest> | undefined, b: UpdateAutoTopupSettingsRequest | PlainMessage<UpdateAutoTopupSettingsRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAutoTopupSettingsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAutoTopupSettingsResponse
 */
export class UpdateAutoTopupSettingsResponse extends Message<UpdateAutoTopupSettingsResponse> {
  /**
   * settings contains the updated auto-topup configuration
   *
   * @generated from field: gitpod.v1.AutoTopupSettings settings = 1;
   */
  settings?: AutoTopupSettings;

  constructor(data?: PartialMessage<UpdateAutoTopupSettingsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAutoTopupSettingsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "settings", kind: "message", T: AutoTopupSettings },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAutoTopupSettingsResponse {
    return new UpdateAutoTopupSettingsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAutoTopupSettingsResponse {
    return new UpdateAutoTopupSettingsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAutoTopupSettingsResponse {
    return new UpdateAutoTopupSettingsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAutoTopupSettingsResponse | PlainMessage<UpdateAutoTopupSettingsResponse> | undefined, b: UpdateAutoTopupSettingsResponse | PlainMessage<UpdateAutoTopupSettingsResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAutoTopupSettingsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAutoTopupSettingsRequest
 */
export class GetAutoTopupSettingsRequest extends Message<GetAutoTopupSettingsRequest> {
  /**
   * organization_id is the ID of the organization to get auto-topup settings for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetAutoTopupSettingsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAutoTopupSettingsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAutoTopupSettingsRequest {
    return new GetAutoTopupSettingsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAutoTopupSettingsRequest {
    return new GetAutoTopupSettingsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAutoTopupSettingsRequest {
    return new GetAutoTopupSettingsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAutoTopupSettingsRequest | PlainMessage<GetAutoTopupSettingsRequest> | undefined, b: GetAutoTopupSettingsRequest | PlainMessage<GetAutoTopupSettingsRequest> | undefined): boolean {
    return proto3.util.equals(GetAutoTopupSettingsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAutoTopupSettingsResponse
 */
export class GetAutoTopupSettingsResponse extends Message<GetAutoTopupSettingsResponse> {
  /**
   * settings contains the current auto-topup configuration
   *
   * @generated from field: gitpod.v1.AutoTopupSettings settings = 1;
   */
  settings?: AutoTopupSettings;

  constructor(data?: PartialMessage<GetAutoTopupSettingsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAutoTopupSettingsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "settings", kind: "message", T: AutoTopupSettings },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAutoTopupSettingsResponse {
    return new GetAutoTopupSettingsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAutoTopupSettingsResponse {
    return new GetAutoTopupSettingsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAutoTopupSettingsResponse {
    return new GetAutoTopupSettingsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAutoTopupSettingsResponse | PlainMessage<GetAutoTopupSettingsResponse> | undefined, b: GetAutoTopupSettingsResponse | PlainMessage<GetAutoTopupSettingsResponse> | undefined): boolean {
    return proto3.util.equals(GetAutoTopupSettingsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCreditUsageReportRequest
 */
export class GetCreditUsageReportRequest extends Message<GetCreditUsageReportRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * Date range for the report. Both start and end dates are inclusive.
   * Time-of-day is ignored; dates are truncated to midnight in the specified timezone.
   * The range must not exceed 31 days.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * IANA timezone name (e.g. "America/New_York", "Europe/Berlin") used to
   * bucket daily usage. When empty, defaults to "UTC".
   *
   * @generated from field: string timezone = 3;
   */
  timezone = "";

  constructor(data?: PartialMessage<GetCreditUsageReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCreditUsageReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditUsageReportRequest {
    return new GetCreditUsageReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditUsageReportRequest {
    return new GetCreditUsageReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditUsageReportRequest {
    return new GetCreditUsageReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditUsageReportRequest | PlainMessage<GetCreditUsageReportRequest> | undefined, b: GetCreditUsageReportRequest | PlainMessage<GetCreditUsageReportRequest> | undefined): boolean {
    return proto3.util.equals(GetCreditUsageReportRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCreditUsageReportResponse
 */
export class GetCreditUsageReportResponse extends Message<GetCreditUsageReportResponse> {
  /**
   * When the report data was last computed.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp;

  /**
   * One entry per day in the requested date range.
   *
   * @generated from field: repeated gitpod.v1.DailyCreditUsage daily_usage = 2;
   */
  dailyUsage: DailyCreditUsage[] = [];

  /**
   * Start of the billing period for this organization.
   * Used by the frontend to filter out months before usage tracking began.
   *
   * @generated from field: optional google.protobuf.Timestamp period_start = 3;
   */
  periodStart?: Timestamp;

  constructor(data?: PartialMessage<GetCreditUsageReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCreditUsageReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "updated_at", kind: "message", T: Timestamp },
    { no: 2, name: "daily_usage", kind: "message", T: DailyCreditUsage, repeated: true },
    { no: 3, name: "period_start", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditUsageReportResponse {
    return new GetCreditUsageReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditUsageReportResponse {
    return new GetCreditUsageReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditUsageReportResponse {
    return new GetCreditUsageReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditUsageReportResponse | PlainMessage<GetCreditUsageReportResponse> | undefined, b: GetCreditUsageReportResponse | PlainMessage<GetCreditUsageReportResponse> | undefined): boolean {
    return proto3.util.equals(GetCreditUsageReportResponse, a, b);
  }
}

/**
 * DailyCreditUsage contains credit usage for a single day.
 *
 * @generated from message gitpod.v1.DailyCreditUsage
 */
export class DailyCreditUsage extends Message<DailyCreditUsage> {
  /**
   * Start of the day (midnight in the requested timezone).
   *
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;

  /**
   * Org-wide usage broken down by type.
   *
   * @generated from field: repeated gitpod.v1.CreditsByType org_usage = 2;
   */
  orgUsage: CreditsByType[] = [];

  /**
   * Per-user usage for this day (top users + "Others").
   *
   * @generated from field: repeated gitpod.v1.UserCreditUsage user_usage = 3;
   */
  userUsage: UserCreditUsage[] = [];

  /**
   * Per-team usage for this day (top teams + "Others").
   * Empty team_id represents the "Others" aggregation bucket.
   *
   * @generated from field: repeated gitpod.v1.TeamCreditUsage team_usage = 4;
   */
  teamUsage: TeamCreditUsage[] = [];

  constructor(data?: PartialMessage<DailyCreditUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DailyCreditUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "message", T: Timestamp },
    { no: 2, name: "org_usage", kind: "message", T: CreditsByType, repeated: true },
    { no: 3, name: "user_usage", kind: "message", T: UserCreditUsage, repeated: true },
    { no: 4, name: "team_usage", kind: "message", T: TeamCreditUsage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DailyCreditUsage {
    return new DailyCreditUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DailyCreditUsage {
    return new DailyCreditUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DailyCreditUsage {
    return new DailyCreditUsage().fromJsonString(jsonString, options);
  }

  static equals(a: DailyCreditUsage | PlainMessage<DailyCreditUsage> | undefined, b: DailyCreditUsage | PlainMessage<DailyCreditUsage> | undefined): boolean {
    return proto3.util.equals(DailyCreditUsage, a, b);
  }
}

/**
 * CreditsByType contains credits consumed for a single usage type.
 *
 * @generated from message gitpod.v1.CreditsByType
 */
export class CreditsByType extends Message<CreditsByType> {
  /**
   * @generated from field: gitpod.v1.UsageType usage_type = 1;
   */
  usageType = UsageType.UNSPECIFIED;

  /**
   * @generated from field: double credits = 2;
   */
  credits = 0;

  constructor(data?: PartialMessage<CreditsByType>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreditsByType";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "usage_type", kind: "enum", T: proto3.getEnumType(UsageType) },
    { no: 2, name: "credits", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditsByType {
    return new CreditsByType().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditsByType {
    return new CreditsByType().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditsByType {
    return new CreditsByType().fromJsonString(jsonString, options);
  }

  static equals(a: CreditsByType | PlainMessage<CreditsByType> | undefined, b: CreditsByType | PlainMessage<CreditsByType> | undefined): boolean {
    return proto3.util.equals(CreditsByType, a, b);
  }
}

/**
 * UserCreditUsage contains a single user's credit usage, broken down by type.
 *
 * @generated from message gitpod.v1.UserCreditUsage
 */
export class UserCreditUsage extends Message<UserCreditUsage> {
  /**
   * Empty when representing the "Others" aggregation bucket.
   *
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string display_name = 2;
   */
  displayName = "";

  /**
   * @generated from field: repeated gitpod.v1.CreditsByType usage = 3;
   */
  usage: CreditsByType[] = [];

  constructor(data?: PartialMessage<UserCreditUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UserCreditUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "usage", kind: "message", T: CreditsByType, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserCreditUsage {
    return new UserCreditUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserCreditUsage {
    return new UserCreditUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserCreditUsage {
    return new UserCreditUsage().fromJsonString(jsonString, options);
  }

  static equals(a: UserCreditUsage | PlainMessage<UserCreditUsage> | undefined, b: UserCreditUsage | PlainMessage<UserCreditUsage> | undefined): boolean {
    return proto3.util.equals(UserCreditUsage, a, b);
  }
}

/**
 * TeamCreditUsage contains a single team's credit usage for a day, broken down by type.
 *
 * @generated from message gitpod.v1.TeamCreditUsage
 */
export class TeamCreditUsage extends Message<TeamCreditUsage> {
  /**
   * Empty when representing the "Others" aggregation bucket.
   *
   * @generated from field: string team_id = 1;
   */
  teamId = "";

  /**
   * @generated from field: string display_name = 2;
   */
  displayName = "";

  /**
   * @generated from field: repeated gitpod.v1.CreditsByType usage = 3;
   */
  usage: CreditsByType[] = [];

  constructor(data?: PartialMessage<TeamCreditUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.TeamCreditUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "usage", kind: "message", T: CreditsByType, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeamCreditUsage {
    return new TeamCreditUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeamCreditUsage {
    return new TeamCreditUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeamCreditUsage {
    return new TeamCreditUsage().fromJsonString(jsonString, options);
  }

  static equals(a: TeamCreditUsage | PlainMessage<TeamCreditUsage> | undefined, b: TeamCreditUsage | PlainMessage<TeamCreditUsage> | undefined): boolean {
    return proto3.util.equals(TeamCreditUsage, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCreditUsageExportRequest
 */
export class GetCreditUsageExportRequest extends Message<GetCreditUsageExportRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * Month to export. Same semantics as GetCreditUsageReport.date_range.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  constructor(data?: PartialMessage<GetCreditUsageExportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCreditUsageExportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditUsageExportRequest {
    return new GetCreditUsageExportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditUsageExportRequest {
    return new GetCreditUsageExportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditUsageExportRequest {
    return new GetCreditUsageExportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditUsageExportRequest | PlainMessage<GetCreditUsageExportRequest> | undefined, b: GetCreditUsageExportRequest | PlainMessage<GetCreditUsageExportRequest> | undefined): boolean {
    return proto3.util.equals(GetCreditUsageExportRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCreditUsageExportResponse
 */
export class GetCreditUsageExportResponse extends Message<GetCreditUsageExportResponse> {
  /**
   * Signed download URL for the CSV export. Short-lived (5 minutes).
   *
   * @generated from field: string download_url = 1;
   */
  downloadUrl = "";

  constructor(data?: PartialMessage<GetCreditUsageExportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCreditUsageExportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "download_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditUsageExportResponse {
    return new GetCreditUsageExportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditUsageExportResponse {
    return new GetCreditUsageExportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditUsageExportResponse {
    return new GetCreditUsageExportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditUsageExportResponse | PlainMessage<GetCreditUsageExportResponse> | undefined, b: GetCreditUsageExportResponse | PlainMessage<GetCreditUsageExportResponse> | undefined): boolean {
    return proto3.util.equals(GetCreditUsageExportResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CorrectUsageEventsRequest
 */
export class CorrectUsageEventsRequest extends Message<CorrectUsageEventsRequest> {
  /**
   * Idempotency keys of events to correct.
   *
   * @generated from field: repeated string idempotency_keys = 1;
   */
  idempotencyKeys: string[] = [];

  /**
   * Why these events are being corrected (stored in cancel_reason and correction payload).
   *
   * @generated from field: string reason = 2;
   */
  reason = "";

  constructor(data?: PartialMessage<CorrectUsageEventsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CorrectUsageEventsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "idempotency_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CorrectUsageEventsRequest {
    return new CorrectUsageEventsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CorrectUsageEventsRequest {
    return new CorrectUsageEventsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CorrectUsageEventsRequest {
    return new CorrectUsageEventsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CorrectUsageEventsRequest | PlainMessage<CorrectUsageEventsRequest> | undefined, b: CorrectUsageEventsRequest | PlainMessage<CorrectUsageEventsRequest> | undefined): boolean {
    return proto3.util.equals(CorrectUsageEventsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CorrectUsageEventsResponse
 */
export class CorrectUsageEventsResponse extends Message<CorrectUsageEventsResponse> {
  /**
   * @generated from field: repeated gitpod.v1.UsageEventCorrectionResult results = 1;
   */
  results: UsageEventCorrectionResult[] = [];

  constructor(data?: PartialMessage<CorrectUsageEventsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CorrectUsageEventsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: UsageEventCorrectionResult, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CorrectUsageEventsResponse {
    return new CorrectUsageEventsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CorrectUsageEventsResponse {
    return new CorrectUsageEventsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CorrectUsageEventsResponse {
    return new CorrectUsageEventsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CorrectUsageEventsResponse | PlainMessage<CorrectUsageEventsResponse> | undefined, b: CorrectUsageEventsResponse | PlainMessage<CorrectUsageEventsResponse> | undefined): boolean {
    return proto3.util.equals(CorrectUsageEventsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UsageEventCorrectionResult
 */
export class UsageEventCorrectionResult extends Message<UsageEventCorrectionResult> {
  /**
   * @generated from field: string idempotency_key = 1;
   */
  idempotencyKey = "";

  /**
   * @generated from field: bool success = 2;
   */
  success = false;

  /**
   * Error message if correction failed (e.g., event not found, already cancelled).
   *
   * @generated from field: string error = 3;
   */
  error = "";

  constructor(data?: PartialMessage<UsageEventCorrectionResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UsageEventCorrectionResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "idempotency_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsageEventCorrectionResult {
    return new UsageEventCorrectionResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsageEventCorrectionResult {
    return new UsageEventCorrectionResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsageEventCorrectionResult {
    return new UsageEventCorrectionResult().fromJsonString(jsonString, options);
  }

  static equals(a: UsageEventCorrectionResult | PlainMessage<UsageEventCorrectionResult> | undefined, b: UsageEventCorrectionResult | PlainMessage<UsageEventCorrectionResult> | undefined): boolean {
    return proto3.util.equals(UsageEventCorrectionResult, a, b);
  }
}

/**
 * @generated from message gitpod.v1.InsertUsageEventsRequest
 */
export class InsertUsageEventsRequest extends Message<InsertUsageEventsRequest> {
  /**
   * Events to insert.
   *
   * @generated from field: repeated gitpod.v1.UsageEventInput events = 1;
   */
  events: UsageEventInput[] = [];

  /**
   * Why these events are being inserted (stored in audit log and event payload).
   *
   * @generated from field: string reason = 2;
   */
  reason = "";

  /**
   * If true, allow events with timestamps older than 35 days.
   * By default, old events are rejected because Stripe cannot accept them.
   *
   * @generated from field: bool ignore_age_check = 3;
   */
  ignoreAgeCheck = false;

  constructor(data?: PartialMessage<InsertUsageEventsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.InsertUsageEventsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "message", T: UsageEventInput, repeated: true },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ignore_age_check", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InsertUsageEventsRequest {
    return new InsertUsageEventsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InsertUsageEventsRequest {
    return new InsertUsageEventsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InsertUsageEventsRequest {
    return new InsertUsageEventsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InsertUsageEventsRequest | PlainMessage<InsertUsageEventsRequest> | undefined, b: InsertUsageEventsRequest | PlainMessage<InsertUsageEventsRequest> | undefined): boolean {
    return proto3.util.equals(InsertUsageEventsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UsageEventInput
 */
export class UsageEventInput extends Message<UsageEventInput> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * Must be a known event type: "environment_usage" or "llm_usage".
   *
   * @generated from field: string event_name = 2;
   */
  eventName = "";

  /**
   * Unix epoch seconds. Raw int64 (not google.protobuf.Timestamp) to match
   * the storage model and allow direct CSV round-tripping.
   *
   * @generated from field: int64 timestamp = 3;
   */
  timestamp = protoInt64.zero;

  /**
   * @generated from field: int64 value = 4;
   */
  value = protoInt64.zero;

  /**
   * @generated from field: optional string user_id = 5;
   */
  userId?: string;

  /**
   * JSON-encoded payload metadata. Validated per event_name by the service.
   *
   * @generated from field: string payload_json = 6;
   */
  payloadJson = "";

  constructor(data?: PartialMessage<UsageEventInput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UsageEventInput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "value", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "payload_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsageEventInput {
    return new UsageEventInput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsageEventInput {
    return new UsageEventInput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsageEventInput {
    return new UsageEventInput().fromJsonString(jsonString, options);
  }

  static equals(a: UsageEventInput | PlainMessage<UsageEventInput> | undefined, b: UsageEventInput | PlainMessage<UsageEventInput> | undefined): boolean {
    return proto3.util.equals(UsageEventInput, a, b);
  }
}

/**
 * @generated from message gitpod.v1.InsertUsageEventsResponse
 */
export class InsertUsageEventsResponse extends Message<InsertUsageEventsResponse> {
  /**
   * One result per input event, in the same order as the request.
   * Each result echoes the original input fields plus status columns,
   * so the CLI can write the response directly to stdout as CSV.
   *
   * @generated from field: repeated gitpod.v1.UsageEventInsertResult results = 1;
   */
  results: UsageEventInsertResult[] = [];

  /**
   * Summary counts.
   *
   * @generated from field: int32 inserted_count = 2;
   */
  insertedCount = 0;

  /**
   * @generated from field: int32 skipped_count = 3;
   */
  skippedCount = 0;

  /**
   * @generated from field: int32 error_count = 4;
   */
  errorCount = 0;

  constructor(data?: PartialMessage<InsertUsageEventsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.InsertUsageEventsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: UsageEventInsertResult, repeated: true },
    { no: 2, name: "inserted_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "skipped_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "error_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InsertUsageEventsResponse {
    return new InsertUsageEventsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InsertUsageEventsResponse {
    return new InsertUsageEventsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InsertUsageEventsResponse {
    return new InsertUsageEventsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InsertUsageEventsResponse | PlainMessage<InsertUsageEventsResponse> | undefined, b: InsertUsageEventsResponse | PlainMessage<InsertUsageEventsResponse> | undefined): boolean {
    return proto3.util.equals(InsertUsageEventsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UsageEventInsertResult
 */
export class UsageEventInsertResult extends Message<UsageEventInsertResult> {
  /**
   * Original input fields echoed back.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * @generated from field: string event_name = 2;
   */
  eventName = "";

  /**
   * Unix epoch seconds (echoed from input).
   *
   * @generated from field: int64 timestamp = 3;
   */
  timestamp = protoInt64.zero;

  /**
   * @generated from field: int64 value = 4;
   */
  value = protoInt64.zero;

  /**
   * @generated from field: string user_id = 5;
   */
  userId = "";

  /**
   * @generated from field: string payload_json = 6;
   */
  payloadJson = "";

  /**
   * "ok", "skipped", or "error".
   *
   * @generated from field: string status = 7;
   */
  status = "";

  /**
   * Generated idempotency key (empty for validation errors before key generation).
   *
   * @generated from field: string idempotency_key = 8;
   */
  idempotencyKey = "";

  /**
   * Error/skip reason (empty for status "ok").
   *
   * @generated from field: string message = 9;
   */
  message = "";

  constructor(data?: PartialMessage<UsageEventInsertResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UsageEventInsertResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "value", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "payload_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "idempotency_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsageEventInsertResult {
    return new UsageEventInsertResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsageEventInsertResult {
    return new UsageEventInsertResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsageEventInsertResult {
    return new UsageEventInsertResult().fromJsonString(jsonString, options);
  }

  static equals(a: UsageEventInsertResult | PlainMessage<UsageEventInsertResult> | undefined, b: UsageEventInsertResult | PlainMessage<UsageEventInsertResult> | undefined): boolean {
    return proto3.util.equals(UsageEventInsertResult, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetEnterpriseBillingInfoRequest
 */
export class GetEnterpriseBillingInfoRequest extends Message<GetEnterpriseBillingInfoRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<GetEnterpriseBillingInfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetEnterpriseBillingInfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEnterpriseBillingInfoRequest {
    return new GetEnterpriseBillingInfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEnterpriseBillingInfoRequest {
    return new GetEnterpriseBillingInfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEnterpriseBillingInfoRequest {
    return new GetEnterpriseBillingInfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetEnterpriseBillingInfoRequest | PlainMessage<GetEnterpriseBillingInfoRequest> | undefined, b: GetEnterpriseBillingInfoRequest | PlainMessage<GetEnterpriseBillingInfoRequest> | undefined): boolean {
    return proto3.util.equals(GetEnterpriseBillingInfoRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetEnterpriseBillingInfoResponse
 */
export class GetEnterpriseBillingInfoResponse extends Message<GetEnterpriseBillingInfoResponse> {
  /**
   * @generated from field: bool credit_usage_enabled = 1;
   */
  creditUsageEnabled = false;

  constructor(data?: PartialMessage<GetEnterpriseBillingInfoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetEnterpriseBillingInfoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "credit_usage_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEnterpriseBillingInfoResponse {
    return new GetEnterpriseBillingInfoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEnterpriseBillingInfoResponse {
    return new GetEnterpriseBillingInfoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEnterpriseBillingInfoResponse {
    return new GetEnterpriseBillingInfoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetEnterpriseBillingInfoResponse | PlainMessage<GetEnterpriseBillingInfoResponse> | undefined, b: GetEnterpriseBillingInfoResponse | PlainMessage<GetEnterpriseBillingInfoResponse> | undefined): boolean {
    return proto3.util.equals(GetEnterpriseBillingInfoResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RequestRecoveryCreditRequest
 */
export class RequestRecoveryCreditRequest extends Message<RequestRecoveryCreditRequest> {
  /**
   * organization_id is the ID of the organization requesting recovery credits
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  constructor(data?: PartialMessage<RequestRecoveryCreditRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RequestRecoveryCreditRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RequestRecoveryCreditRequest {
    return new RequestRecoveryCreditRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RequestRecoveryCreditRequest {
    return new RequestRecoveryCreditRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RequestRecoveryCreditRequest {
    return new RequestRecoveryCreditRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RequestRecoveryCreditRequest | PlainMessage<RequestRecoveryCreditRequest> | undefined, b: RequestRecoveryCreditRequest | PlainMessage<RequestRecoveryCreditRequest> | undefined): boolean {
    return proto3.util.equals(RequestRecoveryCreditRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RequestRecoveryCreditResponse
 */
export class RequestRecoveryCreditResponse extends Message<RequestRecoveryCreditResponse> {
  constructor(data?: PartialMessage<RequestRecoveryCreditResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RequestRecoveryCreditResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RequestRecoveryCreditResponse {
    return new RequestRecoveryCreditResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RequestRecoveryCreditResponse {
    return new RequestRecoveryCreditResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RequestRecoveryCreditResponse {
    return new RequestRecoveryCreditResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RequestRecoveryCreditResponse | PlainMessage<RequestRecoveryCreditResponse> | undefined, b: RequestRecoveryCreditResponse | PlainMessage<RequestRecoveryCreditResponse> | undefined): boolean {
    return proto3.util.equals(RequestRecoveryCreditResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCumulativeCreditUsageRequest
 */
export class GetCumulativeCreditUsageRequest extends Message<GetCumulativeCreditUsageRequest> {
  /**
   * organization_id is the ID of the organization to get cumulative usage for.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * as_of is the point in time to compute cumulative usage up to.
   * Defaults to now if not set.
   *
   * @generated from field: optional google.protobuf.Timestamp as_of = 2;
   */
  asOf?: Timestamp;

  constructor(data?: PartialMessage<GetCumulativeCreditUsageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCumulativeCreditUsageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "as_of", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCumulativeCreditUsageRequest {
    return new GetCumulativeCreditUsageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCumulativeCreditUsageRequest {
    return new GetCumulativeCreditUsageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCumulativeCreditUsageRequest {
    return new GetCumulativeCreditUsageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCumulativeCreditUsageRequest | PlainMessage<GetCumulativeCreditUsageRequest> | undefined, b: GetCumulativeCreditUsageRequest | PlainMessage<GetCumulativeCreditUsageRequest> | undefined): boolean {
    return proto3.util.equals(GetCumulativeCreditUsageRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetCumulativeCreditUsageResponse
 */
export class GetCumulativeCreditUsageResponse extends Message<GetCumulativeCreditUsageResponse> {
  /**
   * Org-wide cumulative usage, broken down by type and total.
   *
   * @generated from field: gitpod.v1.CumulativeCreditUsage org_usage = 1;
   */
  orgUsage?: CumulativeCreditUsage;

  /**
   * Per-team cumulative usage with credit allocation comparison.
   * Returns all teams (no top-N limit).
   *
   * @generated from field: repeated gitpod.v1.TeamCumulativeCreditUsage team_usage = 2;
   */
  teamUsage: TeamCumulativeCreditUsage[] = [];

  /**
   * Usage by members not assigned to any team.
   *
   * @generated from field: gitpod.v1.CumulativeCreditUsage unteamed_usage = 3;
   */
  unteamedUsage?: CumulativeCreditUsage;

  /**
   * Start of the cumulative calculation period.
   * Cumulative totals are computed from this date forward.
   *
   * @generated from field: google.protobuf.Timestamp period_start = 4;
   */
  periodStart?: Timestamp;

  constructor(data?: PartialMessage<GetCumulativeCreditUsageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetCumulativeCreditUsageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "org_usage", kind: "message", T: CumulativeCreditUsage },
    { no: 2, name: "team_usage", kind: "message", T: TeamCumulativeCreditUsage, repeated: true },
    { no: 3, name: "unteamed_usage", kind: "message", T: CumulativeCreditUsage },
    { no: 4, name: "period_start", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCumulativeCreditUsageResponse {
    return new GetCumulativeCreditUsageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCumulativeCreditUsageResponse {
    return new GetCumulativeCreditUsageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCumulativeCreditUsageResponse {
    return new GetCumulativeCreditUsageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCumulativeCreditUsageResponse | PlainMessage<GetCumulativeCreditUsageResponse> | undefined, b: GetCumulativeCreditUsageResponse | PlainMessage<GetCumulativeCreditUsageResponse> | undefined): boolean {
    return proto3.util.equals(GetCumulativeCreditUsageResponse, a, b);
  }
}

/**
 * CumulativeCreditUsage contains cumulative credit consumption totals.
 *
 * @generated from message gitpod.v1.CumulativeCreditUsage
 */
export class CumulativeCreditUsage extends Message<CumulativeCreditUsage> {
  /**
   * Total credits consumed.
   *
   * @generated from field: double total_credits = 1;
   */
  totalCredits = 0;

  /**
   * Credits consumed broken down by usage type.
   *
   * @generated from field: repeated gitpod.v1.CreditsByType usage_by_type = 2;
   */
  usageByType: CreditsByType[] = [];

  constructor(data?: PartialMessage<CumulativeCreditUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CumulativeCreditUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_credits", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "usage_by_type", kind: "message", T: CreditsByType, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CumulativeCreditUsage {
    return new CumulativeCreditUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CumulativeCreditUsage {
    return new CumulativeCreditUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CumulativeCreditUsage {
    return new CumulativeCreditUsage().fromJsonString(jsonString, options);
  }

  static equals(a: CumulativeCreditUsage | PlainMessage<CumulativeCreditUsage> | undefined, b: CumulativeCreditUsage | PlainMessage<CumulativeCreditUsage> | undefined): boolean {
    return proto3.util.equals(CumulativeCreditUsage, a, b);
  }
}

/**
 * TeamCumulativeCreditUsage contains a team's cumulative credit usage and allocation.
 *
 * @generated from message gitpod.v1.TeamCumulativeCreditUsage
 */
export class TeamCumulativeCreditUsage extends Message<TeamCumulativeCreditUsage> {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId = "";

  /**
   * @generated from field: string display_name = 2;
   */
  displayName = "";

  /**
   * Cumulative credit usage for this team.
   *
   * @generated from field: gitpod.v1.CumulativeCreditUsage usage = 3;
   */
  usage?: CumulativeCreditUsage;

  /**
   * The team's credit allocation (budget) in whole credits, if set.
   * Not set means no allocation has been configured for this team.
   *
   * @generated from field: optional int64 credit_budget = 4;
   */
  creditBudget?: bigint;

  constructor(data?: PartialMessage<TeamCumulativeCreditUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.TeamCumulativeCreditUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "usage", kind: "message", T: CumulativeCreditUsage },
    { no: 4, name: "credit_budget", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeamCumulativeCreditUsage {
    return new TeamCumulativeCreditUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeamCumulativeCreditUsage {
    return new TeamCumulativeCreditUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeamCumulativeCreditUsage {
    return new TeamCumulativeCreditUsage().fromJsonString(jsonString, options);
  }

  static equals(a: TeamCumulativeCreditUsage | PlainMessage<TeamCumulativeCreditUsage> | undefined, b: TeamCumulativeCreditUsage | PlainMessage<TeamCumulativeCreditUsage> | undefined): boolean {
    return proto3.util.equals(TeamCumulativeCreditUsage, a, b);
  }
}

/**
 * TeamCreditAllocationInfo represents a team's credit budget allocation.
 *
 * @generated from message gitpod.v1.TeamCreditAllocationInfo
 */
export class TeamCreditAllocationInfo extends Message<TeamCreditAllocationInfo> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string team_id = 2;
   */
  teamId = "";

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId = "";

  /**
   * credit_budget is the allocated credit budget in whole credits.
   *
   * @generated from field: int64 credit_budget = 4;
   */
  creditBudget = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<TeamCreditAllocationInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.TeamCreditAllocationInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "credit_budget", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeamCreditAllocationInfo {
    return new TeamCreditAllocationInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeamCreditAllocationInfo {
    return new TeamCreditAllocationInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeamCreditAllocationInfo {
    return new TeamCreditAllocationInfo().fromJsonString(jsonString, options);
  }

  static equals(a: TeamCreditAllocationInfo | PlainMessage<TeamCreditAllocationInfo> | undefined, b: TeamCreditAllocationInfo | PlainMessage<TeamCreditAllocationInfo> | undefined): boolean {
    return proto3.util.equals(TeamCreditAllocationInfo, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateTeamCreditAllocationRequest
 */
export class CreateTeamCreditAllocationRequest extends Message<CreateTeamCreditAllocationRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * @generated from field: string team_id = 2;
   */
  teamId = "";

  /**
   * credit_budget is the allocated credit budget in whole credits. Must be > 0.
   *
   * @generated from field: int64 credit_budget = 3;
   */
  creditBudget = protoInt64.zero;

  constructor(data?: PartialMessage<CreateTeamCreditAllocationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateTeamCreditAllocationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "credit_budget", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTeamCreditAllocationRequest {
    return new CreateTeamCreditAllocationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTeamCreditAllocationRequest {
    return new CreateTeamCreditAllocationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTeamCreditAllocationRequest {
    return new CreateTeamCreditAllocationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTeamCreditAllocationRequest | PlainMessage<CreateTeamCreditAllocationRequest> | undefined, b: CreateTeamCreditAllocationRequest | PlainMessage<CreateTeamCreditAllocationRequest> | undefined): boolean {
    return proto3.util.equals(CreateTeamCreditAllocationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateTeamCreditAllocationResponse
 */
export class CreateTeamCreditAllocationResponse extends Message<CreateTeamCreditAllocationResponse> {
  /**
   * @generated from field: gitpod.v1.TeamCreditAllocationInfo allocation = 1;
   */
  allocation?: TeamCreditAllocationInfo;

  constructor(data?: PartialMessage<CreateTeamCreditAllocationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateTeamCreditAllocationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "allocation", kind: "message", T: TeamCreditAllocationInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTeamCreditAllocationResponse {
    return new CreateTeamCreditAllocationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTeamCreditAllocationResponse {
    return new CreateTeamCreditAllocationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTeamCreditAllocationResponse {
    return new CreateTeamCreditAllocationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTeamCreditAllocationResponse | PlainMessage<CreateTeamCreditAllocationResponse> | undefined, b: CreateTeamCreditAllocationResponse | PlainMessage<CreateTeamCreditAllocationResponse> | undefined): boolean {
    return proto3.util.equals(CreateTeamCreditAllocationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTeamCreditAllocationRequest
 */
export class GetTeamCreditAllocationRequest extends Message<GetTeamCreditAllocationRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * @generated from field: string team_id = 2;
   */
  teamId = "";

  constructor(data?: PartialMessage<GetTeamCreditAllocationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTeamCreditAllocationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTeamCreditAllocationRequest {
    return new GetTeamCreditAllocationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTeamCreditAllocationRequest {
    return new GetTeamCreditAllocationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTeamCreditAllocationRequest {
    return new GetTeamCreditAllocationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTeamCreditAllocationRequest | PlainMessage<GetTeamCreditAllocationRequest> | undefined, b: GetTeamCreditAllocationRequest | PlainMessage<GetTeamCreditAllocationRequest> | undefined): boolean {
    return proto3.util.equals(GetTeamCreditAllocationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTeamCreditAllocationResponse
 */
export class GetTeamCreditAllocationResponse extends Message<GetTeamCreditAllocationResponse> {
  /**
   * @generated from field: gitpod.v1.TeamCreditAllocationInfo allocation = 1;
   */
  allocation?: TeamCreditAllocationInfo;

  constructor(data?: PartialMessage<GetTeamCreditAllocationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTeamCreditAllocationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "allocation", kind: "message", T: TeamCreditAllocationInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTeamCreditAllocationResponse {
    return new GetTeamCreditAllocationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTeamCreditAllocationResponse {
    return new GetTeamCreditAllocationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTeamCreditAllocationResponse {
    return new GetTeamCreditAllocationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTeamCreditAllocationResponse | PlainMessage<GetTeamCreditAllocationResponse> | undefined, b: GetTeamCreditAllocationResponse | PlainMessage<GetTeamCreditAllocationResponse> | undefined): boolean {
    return proto3.util.equals(GetTeamCreditAllocationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateTeamCreditAllocationRequest
 */
export class UpdateTeamCreditAllocationRequest extends Message<UpdateTeamCreditAllocationRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * @generated from field: string team_id = 2;
   */
  teamId = "";

  /**
   * credit_budget is the new allocated credit budget in whole credits. Must be > 0.
   *
   * @generated from field: int64 credit_budget = 3;
   */
  creditBudget = protoInt64.zero;

  constructor(data?: PartialMessage<UpdateTeamCreditAllocationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateTeamCreditAllocationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "credit_budget", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateTeamCreditAllocationRequest {
    return new UpdateTeamCreditAllocationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateTeamCreditAllocationRequest {
    return new UpdateTeamCreditAllocationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateTeamCreditAllocationRequest {
    return new UpdateTeamCreditAllocationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateTeamCreditAllocationRequest | PlainMessage<UpdateTeamCreditAllocationRequest> | undefined, b: UpdateTeamCreditAllocationRequest | PlainMessage<UpdateTeamCreditAllocationRequest> | undefined): boolean {
    return proto3.util.equals(UpdateTeamCreditAllocationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateTeamCreditAllocationResponse
 */
export class UpdateTeamCreditAllocationResponse extends Message<UpdateTeamCreditAllocationResponse> {
  /**
   * @generated from field: gitpod.v1.TeamCreditAllocationInfo allocation = 1;
   */
  allocation?: TeamCreditAllocationInfo;

  constructor(data?: PartialMessage<UpdateTeamCreditAllocationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateTeamCreditAllocationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "allocation", kind: "message", T: TeamCreditAllocationInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateTeamCreditAllocationResponse {
    return new UpdateTeamCreditAllocationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateTeamCreditAllocationResponse {
    return new UpdateTeamCreditAllocationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateTeamCreditAllocationResponse {
    return new UpdateTeamCreditAllocationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateTeamCreditAllocationResponse | PlainMessage<UpdateTeamCreditAllocationResponse> | undefined, b: UpdateTeamCreditAllocationResponse | PlainMessage<UpdateTeamCreditAllocationResponse> | undefined): boolean {
    return proto3.util.equals(UpdateTeamCreditAllocationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteTeamCreditAllocationRequest
 */
export class DeleteTeamCreditAllocationRequest extends Message<DeleteTeamCreditAllocationRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * @generated from field: string team_id = 2;
   */
  teamId = "";

  constructor(data?: PartialMessage<DeleteTeamCreditAllocationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteTeamCreditAllocationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteTeamCreditAllocationRequest {
    return new DeleteTeamCreditAllocationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteTeamCreditAllocationRequest {
    return new DeleteTeamCreditAllocationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteTeamCreditAllocationRequest {
    return new DeleteTeamCreditAllocationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteTeamCreditAllocationRequest | PlainMessage<DeleteTeamCreditAllocationRequest> | undefined, b: DeleteTeamCreditAllocationRequest | PlainMessage<DeleteTeamCreditAllocationRequest> | undefined): boolean {
    return proto3.util.equals(DeleteTeamCreditAllocationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteTeamCreditAllocationResponse
 */
export class DeleteTeamCreditAllocationResponse extends Message<DeleteTeamCreditAllocationResponse> {
  constructor(data?: PartialMessage<DeleteTeamCreditAllocationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteTeamCreditAllocationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteTeamCreditAllocationResponse {
    return new DeleteTeamCreditAllocationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteTeamCreditAllocationResponse {
    return new DeleteTeamCreditAllocationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteTeamCreditAllocationResponse {
    return new DeleteTeamCreditAllocationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteTeamCreditAllocationResponse | PlainMessage<DeleteTeamCreditAllocationResponse> | undefined, b: DeleteTeamCreditAllocationResponse | PlainMessage<DeleteTeamCreditAllocationResponse> | undefined): boolean {
    return proto3.util.equals(DeleteTeamCreditAllocationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetOrganizationCreditGrantRequest
 */
export class SetOrganizationCreditGrantRequest extends Message<SetOrganizationCreditGrantRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * credit_grant is the contracted credit grant in whole credits. Must be >= 0.
   *
   * @generated from field: int64 credit_grant = 2;
   */
  creditGrant = protoInt64.zero;

  constructor(data?: PartialMessage<SetOrganizationCreditGrantRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetOrganizationCreditGrantRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "credit_grant", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetOrganizationCreditGrantRequest {
    return new SetOrganizationCreditGrantRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetOrganizationCreditGrantRequest {
    return new SetOrganizationCreditGrantRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetOrganizationCreditGrantRequest {
    return new SetOrganizationCreditGrantRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetOrganizationCreditGrantRequest | PlainMessage<SetOrganizationCreditGrantRequest> | undefined, b: SetOrganizationCreditGrantRequest | PlainMessage<SetOrganizationCreditGrantRequest> | undefined): boolean {
    return proto3.util.equals(SetOrganizationCreditGrantRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SetOrganizationCreditGrantResponse
 */
export class SetOrganizationCreditGrantResponse extends Message<SetOrganizationCreditGrantResponse> {
  constructor(data?: PartialMessage<SetOrganizationCreditGrantResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SetOrganizationCreditGrantResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetOrganizationCreditGrantResponse {
    return new SetOrganizationCreditGrantResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetOrganizationCreditGrantResponse {
    return new SetOrganizationCreditGrantResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetOrganizationCreditGrantResponse {
    return new SetOrganizationCreditGrantResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetOrganizationCreditGrantResponse | PlainMessage<SetOrganizationCreditGrantResponse> | undefined, b: SetOrganizationCreditGrantResponse | PlainMessage<SetOrganizationCreditGrantResponse> | undefined): boolean {
    return proto3.util.equals(SetOrganizationCreditGrantResponse, a, b);
  }
}

